import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./orderSummaryPage.css";
import "./media_checkout_details.css";
import "../../components/common/style.css";
import "../../components/common/responsive.css";
import "../../components/common/common.css";
import Header from "../../components/common/header";
import Footer from "../../components/common/footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faHome,
  faCalendar,
  faTimes,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import ProductImage from "../../assets/images/Frame 20.png";
import "../home/homePage.css";
import { format } from "date-fns"; // For date formatting
import { useCart } from "../../contexts/cartContext";
import { useUser } from "../../contexts/userContext";
import Modal from "bootstrap/js/dist/modal";
import "react-datepicker/dist/react-datepicker.css";
import { useRefreshPrice } from "../../contexts/refreshPrice";

interface Address {
  address_id: number;
  user_id: number;
  address_1: string;
  address_2: string;
  landmark: string;
  state: string;
  city: string;
  pincode: string;
  is_default: boolean;
  state_id: string;
}

interface Product {
  product_id: number;
  cat_id: number;
  title: string;
  is_active: number;
  base_value: string;
  img_name: string;
  unit_type: number;
  tag_page: number | null;
  working_price: string | null;
  notworking_price: string | null;
  sess_code: string;
  parent_cat_id: number;
  brand: string | null;
  attributes: any;
}


interface FlashMessageProps {
  message: string;
  onClose: () => void;
}

const OrderSummaryPage = () => {
  const navigate = useNavigate();
  const [quantities, setQuantities] = useState<{
    [productId: number]: number | null;
  }>({});
  const [error, setError] = useState<string | null>(null);
  const [showFlashMessage, setShowFlashMessage] = useState(false);
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [totalValue, setTotalValue] = useState<number>(0);
  const [totalValueSet, setTotalValueSet] = useState<number>(0);
  // const [sess_code, setSessCode] = useState<string | null>(null);
  const { cartQuantity, setCartQuantity } = useCart();
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const { fetchCartQuantity ,handleQuantity, getBannerOrImageAltTag} = useCart();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [timeSlot, setTimeSlot] = useState("");
  const [isAgreed, setIsAgreed] = useState(false); // State for checkbox
  const [selectedAddress, setSelectedAddress] = useState<any | null>(null);
  const location = useLocation();
  const [addressError, setAddressError] = useState<string | null>(null);
  const [order_Number, setOrderNumber] = useState<string | null>(null);
  const [orderDate, setOrderDate] = useState<string | null>(null);
  const [buyNowProduct, setBuyNowProduct] = useState<Product | 0>(0);
  const [addresses, setAddresses] = useState<Address[]>([]);
  const [pickupFees, setPickupFees] = useState<string | null>(null);
  const [selectedAddressId, setSelectedAddressId] = useState<number | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPrice, setshowPrice] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [feesShow, setFeeShow] = useState<boolean | null>(false);
  // const [showPopupAddress, setShowAddressPopup] = useState(false);
  const [popupMsg, setPopupMsg] = useState("");
  const [showPopupAddress, setShowPopupAddress] = useState<number | null>(null);
  const [pinServiceableStatus, setPinServiceableStatus] = useState<
    boolean | null
  >(null);
  const [pinServiceableMessage, setPinServiceableMessage] = useState("");
  const [pickupSlotDate, setPickupSlotDate] = useState<any>(null);
  const [selectPickupSlotDate, setSelectPickupSlotDate] = useState<any>(null);
  const [pickupDateSelectError, setPickupDateSelectError] = useState<any>(null);
  const [pickupDateObj, setPickupDateObj] = useState([]);
  const {
    user_id,
    utm_session_id,
    setUtmSessionId,
    sess_code,
    checkSessionTokenExpirationStatus,
    handleRemoveLocalStorage,
    globalAddressErrors,
    handleAddressErrorChange,
    setSessionCode,
    fetchCsrfToken
  } = useUser();
  const [selectedVouchers, setSelectedVouchers] = useState(
    location.state?.selectedVouchers ? location.state?.selectedVouchers : []
  );
  const [vouchersData, setVouchersData] = useState([]);
  const [voucherMoreDescriptionStatus, setVoucherMoreDescriptionStatus] =
    useState({});
  const [voucherPopupVisible, setVoucherPopupVisible] = useState(false);
  const [itemVoucherApplied, setItemVoucherApplied] = useState({});
  const [applyVoucherButton, setApplyVoucherButton] = useState(
    selectedVouchers.length > 0 ? true : false
  );
  const [appliedCartItemVoucher, setAppliedCartItemVoucher] = useState(
    location.state?.appliedCartItemVoucher
      ? location.state?.appliedCartItemVoucher
      : []
  );
  const [
    removeItemLevelVoucherPopUpStatus,
    setRemoveItemLevelVoucherPopUpStatus,
  ] = useState(false);
  const [removeVoucherPerItemData, setRemoveVoucherPerItemData] = useState<any>(
    {}
  );
  const [
    removeAllItemLevelVoucherPopUpStatus,
    setRemoveAllItemLevelVoucherPopUpStatus,
  ] = useState(false);
  const [appliedDummyVoucherData, setAppliedDummyVoucherData] = useState<any>(
    location.state?.selectedVouchers ? location.state?.selectedVouchers : []
  );
  const [moreButtonIndex, setMoreButtonIndex] = useState<any>(null);
  const [
    removeOrderLevelVoucherPopUpStatus,
    setRemoveOrderLevelVoucherPopUpStatus,
  ] = useState(false);
  const [
    itemOrOrderVoucherSelectionError,
    setItemOrOrderVoucherSelectionError,
  ] = useState("");
  const [cashValueStatus, setCashValueStatus] = useState(false);
  const [cashValueAmount, setCashValueAmount] = useState<any>(null);
  const [voucherValueAmount, setVoucherValueAmount] = useState<any>(null);
  const [voucherValueStatus, setVoucherValueStatus] = useState(false);
  const [pickupFeesAppliedVoucherStatus, setPickupFeesAppliedVoucherStatus] =
    useState(false);
  const {
    setcityName,
    globalSearchTerm,
    setGlobalSearchTerm,
    setUserId,
    setUsername
  } = useUser();
  const [globalpickupFees, setGlobalPickupFees] = useState<string | null>(null);
  const { refreshPriceKey, setRefreshPriceKey } = useRefreshPrice();
  const query = new URLSearchParams(location.search);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  let utmQuery = location.state?.utmQuery;
  let totalPriceOfCart = location.state?.totalPrice;
  const datePickerRef = useRef<any>(null);
  // //console.log("ordersummery: selected vouchers",selectedVouchers)

  utmQuery = utmQuery || localStorage.getItem("utm_query_data");
  // console.log("-----------auth---------iiiiiiiiii", user_id)
  if (!user_id) {
    navigate("/sell-used-appliances");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const utmSource = query.get("utm_source");

  if (utm_session_id) {
    query.set("utm_session_id", utm_session_id);
  }

  // //console.log("utm---------------oooo", utm_session_id)

  const session_code = sess_code;
  // if (!sess_code) {
  //   navigate("/sell-used-appliances2");
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }
  //console.log("-----------auth---------iiiiiiiiii", selectedAddress);

  const cart_id = location.state?.cart_id;
  // const user_id = location.state?.user_id;
  const product_id = location.state?.productId;
  // //console.log("00000000000-----------",auth_token)

  let product_amount: any = null;
  const product = location.state?.product;

  const steps = [
    "Created",
    "Confirmed",
    "Ready for pickup",
    "order-Pickedup",
    "completed",
  ];



  const { auth_token } = useUser(); // Call the hook unconditionally
  const auth_tokenn = auth_token;

  const [address, setAddress] = useState({
    address_id: "",
    customer_name: "",
    mobile_no: "",
    pincode: "",
    address_1: "",
    address_2: "",
    landmark: "",
    city: "",
    state_id: "",
    is_default: 0,
    user_id: user_id,
    cart_id: cart_id,
    sessionCode: session_code,
  });

  const [addressAdd, setNewAddress] = useState({
    address_1: "",
    address_2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    state_id: "",
  });

  useEffect(() => {
    sessionStorage.removeItem("requestData");
    sessionStorage.removeItem("categoryType");
    sessionStorage.removeItem("categoryId");
    if (!user_id) {
      setError("User ID is missing.");
      return;
    }

    const fetchAddress = async () => {
      try {
        const response = await fetch(
          `${backendUrl}${version}Address/${user_id}/${session_code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
              "auth-token": `${auth_token}`,
      
            },
            credentials: "include",
            mode:"cors"                      
          }
        );

        const data = await response.json();
        if (response.ok) {
          if (data.data && data.data.length > 0) {
            // If addresses are present, hide the popup and populate address data
            // setShowPopup(false);
            const firstAddress = data.data[0]; // You can set any logic to select the address
            setAddress({
              ...address,
              customer_name: firstAddress.name,
              mobile_no: firstAddress.mobile_no,
              address_id: firstAddress.address_id,
              address_1: firstAddress.address_1,
              address_2: firstAddress.address_2,
              landmark: firstAddress.landmark,
              city: firstAddress.city,
              state_id: firstAddress.state_id,
              pincode: firstAddress.pincode,
              is_default: firstAddress.is_default ? 1 : 0,
            });
          } else {
            if (!response.ok) {
              //console.error("Error fetching cart items:", response.status, response.statusText);
              
              // Handle 403 Forbidden explicitly
              if (response.status === 403) {
                localStorage.clear()
                sessionStorage.clear()
                setCartQuantity(0)
                setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/sell-used-appliances");
            }, 3000); // Redirect to login if unauthorized
                return;
              }
        
              // throw new Error(`HTTP error! Status: ${response.status}`);
            }
          }
        }
      } catch (err: any) {
        setError("Error fetching address");
      }
    };

    fetchAddress();
  }, [user_id]);

  const FlashMessage: React.FC<FlashMessageProps> = ({ message, onClose }) => {
    useEffect(() => {
      const timer = setTimeout(() => {
        onClose(); // Hide the flash message after 5 seconds
      }, 3000);
  
      return () => clearTimeout(timer); // Cleanup on unmount
    }, [onClose]);
  
    return (
      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Semi-transparent background
          backdropFilter: "blur(10px)", // Blur effect
          WebkitBackdropFilter: "blur(10px)", 
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999, // Ensure it appears above other content

        }}
      >
        <div
          style={{
            backgroundColor: "#db5f5f",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 1000, // Ensure it's on top of blur
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          Session Expired. Please login to continue.
        </div>
      </div>
    );
  };

  const handlePrivacy = () => {
    window.open("/privacy-policy", "_blank");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleTermsOfConditions = () => {
    window.open("/terms-and-conditions", "_blank");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (addresses.length > 0) {
      setSelectedAddressId(addresses[0].address_id);
      setSelectedAddress(addresses[0]);
      fetchSelectPickupSlotDate(addresses[0].pincode);
      fetchPriceByPincode();
    }
  }, [addresses]);

  const handleDateChange = (date: any) => {
    setStartDate(date);
    //console.log("set---date-----", startDate);
  };

  const formattedDate = format(startDate, "yyyy-MM-dd HH:mm:ss");

  const fetchAddresses = async () => {
    try {
      const response = await fetch(
        `${backendUrl}${version}All-Address/${user_id}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"                
        }
      );

      const data = await response.json();
      if (response.ok) {
        if (data.data) {
          setAddresses(data.data as Address[]); // Cast to Address array
        } else {
          setError("No address found for this user.");
        }
      }else{
        if (!response.ok) {
          //console.error("Error fetching cart items:", response.status, response.statusText);
          
          // Handle 403 Forbidden explicitly
          if (response.status === 403) {
             
            localStorage.clear()
            sessionStorage.clear()  
            setCartQuantity(0)
            setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/sell-used-appliances");
            }, 3000);
            return;
          }
    
          // throw new Error(`HTTP error! Status: ${response.status}`);
        }
      }
    } catch (err: any) {
      setError("Error fetching address");
    }
  };

  const fetchPriceByPincode = async () => {
    try {
      let pincode =
        addressAdd.pincode === ""
          ? selectedAddress.pincode
          : addressAdd.pincode;
      const response = await fetch(
        `${backendUrl}${version}update-price/${pincode}/${sess_code}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"                 
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
           
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(0)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }
  
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.data) {
        // console.log("data-price---updated", data.data);
        fetchCartItems();
      } else {
        // setError("No address found for this user.");
      }
    } catch (err: any) {
      // setError("Error fetching address: " + err.message);
    }
  };

  const fetchSeoMetaDetails = async () => {
    try {
        const code = 'order_checkout_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
              "auth-token": `${auth_token}`,
      
            },
            credentials: "include",
            mode:"cors"                   
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };

  useEffect(() => {
    if (isLoading) {
      document.body.classList.add("disable-scroll");
    } else {
      document.body.classList.remove("disable-scroll");
    }

    return () => {
      document.body.classList.remove("disable-scroll");
    };
  }, [isLoading]);

  useEffect(() => {
   
    fetchAddresses();
    if (session_code) {
      fetchCartQuantity(session_code);
    }
    fetchCartItems();
  }, [user_id, session_code]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleAddressErrorChange(e);
    const { name, value } = e.target;
    // Validate the length: minimum of 2, maximum of 50 characters

    setNewAddress((prevState) => ({
      ...prevState,
      [name]: value.trimStart(),
    }));
  };

  const validateAddress = (value: string) => {
    if (value.length < 2) {
      setAddressError("Address must be at least 2 characters long.");
    } else {
      setAddressError(null);
    }
  };

  const handleSubmitAddress = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();

    if (!isAgreed) {
      setError("Please accept Terms & Conditions."); // Set the error message
      if (pickupDateObj.length > 0) {
          if (!pickupSlotDate) {
            setPickupDateSelectError("Please select a pickup date.");
            datePickerRef.current?.setFocus();
            return;
          }
        }

        return false; // Do not proceed if checkbox is not checked
      }
      // console.log("pickupDateObj.length > 0", pickupDateObj.length);
      if (pickupDateObj.length > 0) {
        if (!pickupSlotDate) {
          setPickupDateSelectError("Please select a pickup date.");
          datePickerRef.current?.setFocus();
          return;
        }
      }

    const isServiceable = await checkPincodeWhenAdd(addressAdd.pincode);
    //console.log("----------->addresss----------", addressAdd);
    if (addressAdd.address_1 == "") {
      setPopupMsg("Please fill address all required feilds");
      setShowModalInfo(true);
      // alert();
    } else if (addressAdd.address_2 == "") {
      setPopupMsg("Please fill address all required feilds");
      setShowModalInfo(true);
      // alert();
    } else if (addressAdd.pincode == "") {
      setPopupMsg("Please enter pincode");
      setShowModalInfo(true);
      // alert();
    } else if (isServiceable === false) {
      setPopupMsg("Your Pincode is not serviceable");
      setShowModalInfo(true);
      // alert();
      return false; // Exit early
    } else {
      
      try {
        const csrfToken = await fetchCsrfToken();
        const response = await fetch(
          `${backendUrl}api/v2/add-Address/${user_id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": `${auth_token}`,
              'X-CSRF-Token': csrfToken,
              
            },
            credentials: "include",
            body: JSON.stringify({
              addressAdd,
            }),
            
            
          }
        );

        if (!response.ok) {
          //console.error("Error fetching cart items:", response.status, response.statusText);
          
          // Handle 403 Forbidden explicitly
          if (response.status === 403) {
             
            localStorage.clear()
            sessionStorage.clear()
            setCartQuantity(0)
            setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/sell-used-appliances");
            }, 3000);
            return;
          }
    
          // throw new Error(`HTTP error! Status: ${response.status}`);
        }
        setNewAddress({
          address_1: "",
          address_2: "",
          landmark: "",
          city: "",
          state: "",
          pincode: "",
          state_id: "",
        });

        fetchAddresses();
        setShowPopup(false); // Close popup on success
        return true; // Indicate success
      } catch (error) {
        //console.error("Error adding address:", error);
        setPopupMsg("Failed to add address");
        setShowModalInfo(true);
        // alert();
        return false; // Indicate failure
      }
    }
  };

  const handleSubmitAddressOnModal = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();

    // const isServiceable = await checkPincodeServiceable(addressAdd.pincode);
    // //console.log("-----order----", isServiceable)

    // if (!isAgreed) {
    //     setError('Please accept Terms & Conditions.'); // Set the error message
    //     return; // Do not proceed if checkbox is not checked
    // }
    // if (isServiceable == false) {
    //     alert('Your Pincode is not serviceable')
    //     return;
    // }

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/add-Address/${user_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({
            addressAdd,
          }),
          
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
           
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(0)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }
  
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
      setNewAddress({
        address_1: "",
        address_2: "",
        landmark: "",
        city: "",
        state: "",
        pincode: "",
        state_id: "",
      });
      fetchAddresses();
      const modalElement = document.getElementById("exampleModal");
      if (modalElement) {
        const modalInstance =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modalInstance.hide();
      }
      window.location.reload();
      setShowPopup(false); // Close popup on success
    } catch (error) {
      //console.error("Error adding address:", error);
      setPopupMsg("Failed to add address");
      setShowModalInfo(true);
      // alert("Failed to add address");
    }
  };

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();

    const isServiceable = await checkPincodeServiceable(addressAdd.pincode);
    //console.log("-----order----", isServiceable);

    // if (!isAgreed) {
    //     setError('Please accept Terms & Conditions.'); // Set the error message
    //     return; // Do not proceed if checkbox is not checked
    // }
    if (isServiceable == false) {
      setPopupMsg("Your Pincode is not serviceable");
      setShowModalInfo(true);
      // alert();
      return;
    }

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/add-Address/${user_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({
            addressAdd,
          }),
          
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
           
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(0)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }
  
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
      setNewAddress({
        address_1: "",
        address_2: "",
        landmark: "",
        city: "",
        state: "",
        pincode: "",
        state_id: "",
      });
      fetchAddresses();
      setShowPopup(false); // Close popup on success
    } catch (error) {
      //console.error("Error adding address:", error);
      setPopupMsg("Failed to add address");
      setShowModalInfo(true);
      // alert("Failed to add address");
    }
  };

  const handleUpdateAddressSubmit = async (
    e: React.FormEvent,
    address_id: any
  ) => {
    e.preventDefault();
    
    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/update-user-Address/${address_id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({
            addressAdd,
          }),
          
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
           
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(0)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }
  
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
      setNewAddress({
        address_1: "",
        address_2: "",
        landmark: "",
        city: "",
        state: "",
        pincode: "",
        state_id: "",
      });
      fetchAddresses();
      setTimeout(() => {
        //console.log("-------->>>>>>>>>nnnnnnnnnmmmmmmmm",totalPriceOfCart,totalValue)
      if (!session_code) {
        setError("Session code is missing.");
        return;
      }
        setRefreshPriceKey((prevKey: number) => prevKey + 1);
        //console.log('Refresh triggered');
    }, 1000);
      // alert('Address added successfully');
      setShowPopupAddress(null); // Close popup on success
    } catch (error) {
      //console.error("Error adding address:", error);
      setPopupMsg("Failed to add address");
      setShowModalInfo(true);
      // alert("Failed to add address");
    }
  };

  const handlePincodeChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    // Allow only digits and limit input to 6 characters
    if (/^\d{0,6}$/.test(value)) {
      setNewAddress((prevState) => ({
        ...prevState,
        pincode: value,
      }));
      setPinServiceableMessage("");
      setPinServiceableStatus(false);
      setPickupDateSelectError("")

      if (value.length === 6) {
        // Check if the pincode is 6 digits
        // fetchPriceByPincode();
        try {
          const response = await fetch(`${backendUrl}api/v2/pincode/${value}`,  {  
            method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
              "auth-token": `${auth_token}`,
      
            },
            credentials: "include",
            mode:"cors"                   
          });

          if (!response.ok) {
            //console.error("Error fetching cart items:", response.status, response.statusText);
            
            // Handle 403 Forbidden explicitly
            if (response.status === 403) {
               
              localStorage.clear()
              sessionStorage.clear()
              setCartQuantity(0)
              setShowFlashMessage(true);
              setTimeout(() => {
                navigate("/sell-used-appliances");
              }, 3000);
              return;
            }
      
            // throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();

          if (data.data) {
            const { city, state } = data.data;
            if (Object.keys(data.data).length === 0) {
              setNewAddress((prevState) => ({
                ...prevState,
                city: "",
                state: "",
              }));
              setPinServiceableMessage("Pincode is not serviceable");
              setPinServiceableStatus(true);
            } else {
              setNewAddress((prevState) => ({
                ...prevState,
                city,
                state,
              }));
              setPickupDateSelectError("")
              await fetchSelectPickupSlotDate(value);
              setPinServiceableMessage("");
              setPinServiceableStatus(false);
            }
          } else {
            // Handle case where no data is found
            //console.error("No data found for pincode");
            setNewAddress((prevState) => ({
              ...prevState,
              city: "",
              state: "",
            }));
            setPinServiceableMessage("Pincode is not serviceable");
            setPinServiceableStatus(true);
          }
        } catch (error) {
          //console.error("Error fetching pincode data:", error);
          setNewAddress((prevState) => ({
            ...prevState,
            city: "",
            state: "",
          }));
          setPinServiceableMessage("Pincode is not serviceable");
          setPinServiceableStatus(true);
        }
      }
    }
  };

  useEffect(() => {
    fetchPriceByPincode();
  }, [refreshPriceKey]);

  // Handle address change
  const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const addressId = Number(e.target.value);
    const selected: any = addresses.find(
      (address) => address.address_id === addressId
    );
    setSelectedAddressId(addressId);
    setSelectedAddress(selected); // Store selected address object
    setPickupSlotDate(null);
    setSelectPickupSlotDate(null);
    setPickupDateSelectError(null);
    fetchSelectPickupSlotDate(selected.pincode);
    setTimeout(() => {
      //console.log("-------->>>>>>>>>nnnnnnnnnmmmmmmmm",totalPriceOfCart,totalValue)
    if (!session_code) {
      setError("Session code is missing.");
      return;
    }
      setRefreshPriceKey((prevKey: number) => prevKey + 1);
      //console.log('Refresh triggered');
  }, 1000);
  };

  const fetchCartItems = async () => {
    try {
      const response = await fetch(
        `${backendUrl}${version}cart-items/${session_code}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"                
        }
      );
      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
           
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(0)
          setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/sell-used-appliances");
            }, 3000);
          return;
        }
  
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      if (result.data.data.length !== 0 && Array.isArray(result.data.data)) {
        const itemsWithQuantity = result.data.data.map((item: any) => ({
          ...item,
        }));

        setCartItems(itemsWithQuantity);
        // //console.log("------->>>>>>>>>>>>>>>>>>>cccccccaaaaaaaaa",totalPriceOfCart,totalValue)
        calculateTotalValue(itemsWithQuantity);
      }
    } catch (err: any) {
      setError(err.message);
    }
  };

  const checkPincodeWhenAdd = async (pincode: any) => {
    try {
      const response = await fetch(
        `${backendUrl}${version}check-pincode-service/${pincode}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"                
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
           
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(0)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }
  
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      //console.log("----->>>>service---", data.data.success);
      if (data.data.success == true) {
        return true; // Address is serviceable
      } else {
        setError("Your pincode is not serviceable.");
        return false; // Address is not serviceable
      }
    } catch (err: any) {
      setError("Error checking pincode serviceability: ");
      return false; // In case of an error, treat it as not serviceable
    }
  };

  const checkPincodeServiceable = async (address_id: any) => {
    try {
      const response = await fetch(
        `${backendUrl}${version}check-pincode/${address_id}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"                 
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
           
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(0)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }
  
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      //console.log("----->>>>service---", data.data.success);
      if (data.data.success == true) {
        return true; // Address is serviceable
      } else {
        setError("Your pincode is not serviceable.");
        return false; // Address is not serviceable
      }
    } catch (err: any) {
      setError("Error checking pincode serviceability");
      return false; // In case of an error, treat it as not serviceable
    }
  };

  const handleButtonClick = async () => {

    if (selectedAddressId) {
      const isServiceable = await checkPincodeServiceable(selectedAddressId);

      if (cartItems.length == 0) {
        navigate("/sell-used-appliances");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      if (!isFormValid) {
        setPopupMsg("Please Fill required feilds.");
        setShowModalInfo(true);
        // alert();
      }

      if (!isAgreed) {
        setError("Please accept Terms & Conditions."); // Set the error message
        // console.log("pickupDateObj.length > 0 !isAgreed", pickupDateObj.length);
        if (pickupDateObj.length > 0) {
          if (!pickupSlotDate) {
            setPickupDateSelectError("Please select a pickup date.");
            datePickerRef.current?.setFocus();
            return;
          }
        }

        return; // Do not proceed if checkbox is not checked
      }
      // console.log("pickupDateObj.length > 0", pickupDateObj.length);
      if (pickupDateObj.length > 0) {
        if (!pickupSlotDate) {
          setPickupDateSelectError("Please select a pickup date.");
          datePickerRef.current?.setFocus();
          return;
        }
      }

      if (isServiceable == false) {
        setPopupMsg("Your Pincode is not serviceable");
        setShowModalInfo(true);
        // alert();
        return; // If the pincode is not serviceable, stop the process here
      } else {
        const checkout ='checkout'
        const csrfToken = await fetchCsrfToken();
          const response = await fetch(
            `${backendUrl}api/v2/user-log/${user_id}/${sess_code}?checkout=${checkout}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "auth-token": `${auth_token}`,
                'X-CSRF-Token': csrfToken,
              },
              credentials: "include",
            }
          );
        setShowConfirmationPopup(true);
        // OrderCompleteRequest();
      }
    } else {
      // console.log("else button  lickkkk");
      const isSubmitSuccessful = await handleSubmitAddress();
      if (isSubmitSuccessful) {
        const checkout ='checkout'
  const csrfToken = await fetchCsrfToken();
    const response = await fetch(
      `${backendUrl}api/v2/user-log/${user_id}/${sess_code}?checkout=${checkout}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
      }
    );
        setShowConfirmationPopup(true); // Call only if handleSubmit is successful
      }

      // OrderCompleteRequest();
    }

  };

  const OrderCompleteRequest = async () => {
    setIsLoading(true);
    try {
      let pickupfees 
      if(feesShow == false){
        pickupfees = 0
      }else {
        pickupfees = pickupFees
      }
      const appliedVoucher = await getAppliedVoucherData();
      const csrfToken = await fetchCsrfToken();
      const ipResponse = await fetch("https://api.ipify.org?format=json");
                        const ipData = await ipResponse.json();
                        const ip_address = ipData.ip;
      
      const response = await fetch(
        `${backendUrl}${version}order-complete/${session_code}?${utmQuery}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({
            address_id: selectedAddressId,
            session_code: session_code,
            pickup_date: selectPickupSlotDate ? selectPickupSlotDate : null, // Format date as 'YYYY-MM-DD'
            time_slot: timeSlot,
            user_id: user_id,
            cart_id: cart_id,
            product: product,
            pickup_fees: pickupFeesAppliedVoucherStatus ? 0 : pickupfees,
            applied_vouchers: appliedVoucher,
            ip_address:ip_address
          }),
          
        }
      );
      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          sessionStorage.removeItem("session_code");
      localStorage.removeItem("sess_code");
      localStorage.removeItem("cartQuantity");
      setCartQuantity(0);
      setSessionCode("");
      localStorage.removeItem("utm_query_data");
      sessionStorage.removeItem("sessionSelectedVoucher");
      sessionStorage.removeItem("sessionAppliedRemoveCartItemVoucher");
      // setSessCode(null);
      setError(""); // Clear the error message if checkbox is checked
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(0)
          setIsLoading(false);
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }
  
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
      

      const data = await response.json();
      if (response.ok) {
        // setShowModal(true);
        setOrderNumber(data.data.orderNumber);
        setOrderDate(data.data.orderDate);
        setIsLoading(false);
        // setShowModal(true);
        sessionStorage.removeItem("session_code");
        localStorage.removeItem("sess_code");
        localStorage.removeItem("cartQuantity");
        setCartQuantity(0);
        setSessionCode("");
        localStorage.removeItem("utm_query_data");
        sessionStorage.removeItem("sessionSelectedVoucher");
        sessionStorage.removeItem("sessionAppliedRemoveCartItemVoucher");
        
        // setSessCode(null);
        setError(""); // Clear the error message if checkbox is checked
        navigate("/order-submit",{state:{orderNumber:data.data.orderNumber,pickupDate:data.data.orderDate,mobileNumber:data.data.mobileNumber,emailId:data.data.email,autoAssign:data.data.auto_assign}})
        
        
      } else {
        // if (!response.ok) {
        //   //console.error("Error fetching cart items:", response.status, response.statusText);
          
        //   // Handle 403 Forbidden explicitly
        //   if (response.status === 403) {
        //     sessionStorage.removeItem("session_code");
        // localStorage.removeItem("sess_code");
        // localStorage.removeItem("cartQuantity");
        // setCartQuantity(0);
        // setSessionCode("");
        // localStorage.removeItem("utm_query_data");
        // sessionStorage.removeItem("sessionSelectedVoucher");
        // sessionStorage.removeItem("sessionAppliedRemoveCartItemVoucher");
        
        // // setSessCode(null);
        // setError(""); // Clear the error message if checkbox is checked
        //     localStorage.clear()
        //     sessionStorage.clear()
        //     setCartQuantity(0)
        //     setShowFlashMessage(true);
        //     setTimeout(() => {
        //       // navigate("/sell-used-appliances");
        //     }, 3000);
        //     return;
        //   }
    
        //   throw new Error(`HTTP error! Status: ${response.status}`);
        // }
        setIsLoading(false);
        setError(data.message || "Failed to complete the order.");

      }
      setIsPopupOpen(true);
    } catch (err: any) {
      setIsLoading(false);
      setError("Error completing order");
    }
  };

  const handleConfirmOrder = async () => {
    //console.log("Order completed!");
   await OrderCompleteRequest();

    // Show success modal after order is completed
    setShowConfirmationPopup(false); // Close confirmation popup
  };

  const handleGotItClick = () => {
    // setShowModal(false); // Close the modal
    setSessionCode("");
    navigate("/profile"); // Redirect to home page
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCloseModalClick = () => {
    setError("");
    setShowModalInfo(false); // Close the modal
  };

  const isFormValid = () => {
    return (
      addressAdd.address_1.length >= 2 &&
      addressAdd.address_2.length >= 2 &&
      addressAdd.pincode.length === 6 &&
      addressAdd.city.length > 0
    );
  };

  const calculateTotalValue = (items: any[]) => {
    const total = items.reduce(
      (acc, item) => acc + parseFloat(item.base_value) * item.quantity,
      0
    );
    const quantity = items.reduce((acc, item) => acc + item.quantity, 0);
    if(addresses.length === 0){
      setshowPrice(false)
    }else{
      if(totalPriceOfCart == total){
     
        setTotalValueSet(total)
        setshowPrice(false)
      }else{
        // setTotalValueSet(total)
        setshowPrice(true)
      }
      if(totalValueSet == total){
        setTotalValueSet(total)
        setshowPrice(false)
      }else{
        setTotalValueSet(total)
        setshowPrice(true)
      }
    }
 

    setTotalValue(total);
    PickupFeeCheck(total);

  };

  // useEffect(() => {
  //   calculateTotalValue(cartItems || product.base_value);

  // }, [cartItems]);

  // useEffect(() => {
  //   if (checkSessionTokenExpirationStatus()) {
  //     // alert("Session token expired");
  //     navigate("/");

  //     window.scrollTo({ top: 0, behavior: "smooth" });
  //     handleQuantity()
  //     handleRemoveLocalStorage()
  //     // window.location.reload();
  //   }
  //   fetchSeoMetaDetails()
    
  // }, []);

  useEffect(() => {
    const isSessionHandled = sessionStorage.getItem("sessionHandled");
  
    // If the session was already handled, avoid running this logic again
    if (isSessionHandled) return;

  
    if (checkSessionTokenExpirationStatus()) {
      // Clear session-related operations
      handleQuantity();
      handleRemoveLocalStorage();
  
      // Set the sessionHandled flag to true to prevent re-execution after reload
      sessionStorage.setItem("sessionHandled", "true");
  
      // Redirect to the homepage
      // navigate("/");
  
      // Reload the page to clear cache
      window.location.reload();
    }
    fetchSeoMetaDetails()

  }, []);

  const fetchSelectPickupSlotDate = async (pincode: any = null) => {
    let fromDate = new Date(new Date().setDate(new Date().getDate() + 2))
      .toISOString()
      .split("T")[0];

    try {
      if (!pincode) {
        pincode =
          addressAdd.pincode === ""
            ? selectedAddress.pincode
            : addressAdd.pincode;
      }
      const response: any = await fetch(
        `${backendUrl}api/v1/warehouse/order-assign-slots?from_date=${fromDate}&pincode=${pincode}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"                 
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
           
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(0)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }
  
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const alloweddate = data.data.map(
        (date: any) =>
          new Date(new Date(date).setDate(new Date(date).getDate() - 1))
      );
      
      setPickupDateObj(
        alloweddate
      );
      //console.log("response order assign slot --->", data);
    } catch (e) {
      //console.log("response order assign slot error --->", e);
    }
    //console.log("from date:", fromDate);
  };
  // Convert string dates to Date objects

  const [selectedDate, setSelectedDate] = useState(null);

  // Filter to allow only dates in the allowedDates array
  const isPickupDateAllowed = (date: any) => {
    const formattedDate = date.toISOString().split("T")[0];
    // //console.log("formattedDate", formattedDate);
    return pickupDateObj.some(
      (allowedDate) =>
        new Date(allowedDate).toISOString().split("T")[0] === formattedDate
    );
    // const data = ["2024-12-14","2024-12-16"]
    // const formattedDate = date.toISOString().split("T")[0]; // Format the date to "YYYY-MM-DD"
    // const allowedDates = pickupDateObj.map(
    //   (allowedDate) => new Date(allowedDate).toISOString().split("T")[0]
    // );

    // // Check if the formatted date is within the allowed range
    // return allowedDates.includes(formattedDate);
  };

  const PickupFeeCheck = async (total: any) => {
    try {
      // //console.log("-----order----6786876798", selectedAddressId);

      const response = await fetch(
        `${backendUrl}${version}pickup-by-order/${total}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"                 
        }
      );

      const data = await response.json();
      if (response.ok) {
        if (data.data.showfees == true) {
         
          const pickupFees = data.data.pickup_fees ?? 0;
          
          if (total !== null && total < pickupFees) {
            setPickupFees(String(total));
          } else {
            setPickupFees(String(pickupFees));
          }
          setGlobalPickupFees(data.data.pickup_fees_global);
          setFeeShow(true);
        } else {
          setFeeShow(false);
         
          const pickupFees = data.data.pickup_fees ?? 0;
        
            if (total !== null && total < pickupFees) {
              setPickupFees(String(total));
            } else {
              setPickupFees(String(pickupFees));
            }
        }
      } else {
        if (!response.ok) {
          //console.error("Error fetching cart items:", response.status, response.statusText);
          
          // Handle 403 Forbidden explicitly
          if (response.status === 403) {
             
            localStorage.clear()
            sessionStorage.clear()
            setCartQuantity(0)
            setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/sell-used-appliances");
            }, 3000);
            return;
          }
    
          // throw new Error(`HTTP error! Status: ${response.status}`);
        }
      }
      //   setIsPopupOpen(true);
    } catch (err: any) {
      setError("Error completing order");
    }
  };

  useEffect(() => {
    if (cartItems.length > 0) {
      preSelectedVoucherData();
    }
  }, [cartItems]);

  const selectedVoucherApplied = (product_id: any, cart_item_id: any) => {
    if (applyVoucherButton) {
      // let selectedVoucher = selectedVouchers.find((vo: any) => {
      //   let product_id_array = vo.apply_condition?.split(",")
      //   return product_id_array.includes(product_id.toString())
      // })
      // if (selectedVoucher?.voucher_id) {
      //   return true
      // }
      if (selectedVouchers.length > 0) {
        let itemVoucher = appliedCartItemVoucher.find(
          (ct: any) =>
            ct.product_id === product_id && ct.cart_item_id === cart_item_id
        );
        if (itemVoucher) {
          return true;
        }
      } else {
        return false;
      }
    }
    return false;
  };
  const selectedVoucherLabel = (product_id: any) => {
    if (applyVoucherButton) {
      let selectedVoucher = selectedVouchers.find((vo: any) => {
        let product_id_array = vo.apply_condition?.split(",");
        return product_id_array.includes(product_id.toString());
      });
      if (selectedVoucher?.voucher_id) {
        return ` ${selectedVoucher.identifier} is applied `;
      }
    }
  };
  const getVoucherIdPerRemove = (product_id: any) => {
    if (applyVoucherButton) {
      let selectedVoucher = selectedVouchers.find((vo: any) => {
        let product_id_array = vo.apply_condition?.split(",");
        return product_id_array.includes(product_id.toString());
      });
      if (selectedVoucher?.voucher_id) {
        return selectedVoucher.voucher_id;
      }
    }
  };

  const preSelectedVoucherData = async () => {
    let apiVouchersData=await getVouchersData()
    let sessionSelectedVoucher = sessionStorage.getItem("sessionSelectedVoucher")
    //console.log("if outside sesssion stoage",sessionSelectedVoucher)
    if (sessionSelectedVoucher) {
      let selectedVoucherData = JSON.parse(sessionSelectedVoucher);
      //console.log("selectedVoucherData------->sesssion", selectedVoucherData);
      let selectedVoucher: any = []
      //console.log("sesssion voucher data:", apiVouchersData);
      selectedVoucherData.forEach((v: any) => {
        let voucherData = apiVouchersData.find(
          (vo: any) => vo.voucher_id === v
        );
        //console.log("session voucher data find out", voucherData);
        if (voucherData) {
          selectedVoucher.push(voucherData);
        }
      })
      //console.log("selectedVoucher--------session", selectedVoucher);
      setSelectedVouchers(selectedVoucher)
      // setSelectedSessionStorageVoucher(selectedVoucher);
      let appliedVouchersData =
        appliedVoucherWithPerticularCartItem(selectedVoucher);
      setAppliedCartItemVoucher(appliedVouchersData);
      setAppliedDummyVoucherData([...selectedVoucher]);
      if (selectedVoucher.length > 0) {
        setApplyVoucherButton(true);
        checkPickupFeesWaivedFromAddVoucher(appliedVouchersData);
      }
    } else {
      setSelectedVouchers([]);
      // setSelectedSessionStorageVoucher(selectedVoucher);

      let appliedVouchersData =
        appliedVoucherWithPerticularCartItem([]);
     
      setAppliedCartItemVoucher(appliedVouchersData);
      setAppliedDummyVoucherData([]);
      checkPickupFeesWaivedFromAddVoucher(appliedVouchersData);
    }
  };

  const removeSelectedSingleItemVoucher = (
    product_id: any,
    cart_item_id: any
  ) => {
    let appliedVoucherRemove = removeAppliedVoucherWithCartProductId(product_id);
    //console.log("removeSelectedItemVoucher------->", appliedVoucherRemove);
    if (appliedVoucherRemove.length > 1) {
      let appliedVoucher = removeAppliedVoucherWithCartItemId(cart_item_id);
      setAppliedCartItemVoucher(appliedVoucher);

      setSessionAppliedCartItemVoucherRemove(cart_item_id);
      checkPickupFeesWaivedFromAddVoucher(appliedVoucher);
    } else {
      let appliedVoucher = removeAppliedVoucherWithCartItemId(cart_item_id);
      setAppliedCartItemVoucher(appliedVoucher);
      setSessionAppliedCartItemVoucherRemove(cart_item_id);
      checkPickupFeesWaivedFromAddVoucher(appliedVoucher);
      let selectedVoucher = selectedVouchers.find((vo: any) => {
        let product_id_array = vo.apply_condition?.split(",");
        return product_id_array.includes(product_id.toString());
      });
      if (selectedVoucher?.voucher_id) {
        let data = selectedVouchers.filter(
          (v: any) => v.voucher_id !== selectedVoucher.voucher_id
        );
        //console.log("removeSelectedItemVoucher------->", data);
        if (data && data.length === 0 && selectedVouchers.length === 1) {
          setSelectedVouchers([]);
          setAppliedDummyVoucherData([]);
          setSelectedSessionStorageVoucher([]);
          setApplyVoucherButton(false);
        } else if (data && data.length > 0) {
          //console.log("else if enter");
          setSelectedVouchers(data);
          setSelectedSessionStorageVoucher(data);
          setAppliedDummyVoucherData(data);
        }
      }
    }
  };
  const removeAppliedVoucherWithCartItemId = (cart_item_id: any) => {
    let appliedVoucher = appliedCartItemVoucher.filter(
      (ct: any) => ct.cart_item_id !== cart_item_id
    );
   
    return appliedVoucher;
  };
  const removeAppliedVoucherWithCartProductId = (product_id: any) => {
    let appliedVoucher = appliedCartItemVoucher.filter(
      (ct: any) =>
        ct.product_id === product_id ||
        ct.voucher_id === removeVoucherPerItemData.voucher_id
    );
    return appliedVoucher;
  };

  const getOrderVoucherApplied = () => {
    if (applyVoucherButton) {
      for (let i = 0; i < selectedVouchers.length; i++) {
        if (selectedVouchers[i].depends_on === 1) {
          return true;
        }
      }
    }
    return false;
  };
  const getOrderVoucherValueStatus = () => {
    if (applyVoucherButton) {
      for (let i = 0; i < selectedVouchers.length; i++) {
        if (selectedVouchers[i].depends_on === 1) {
          return true;
        }
      }
    }
    return false;
  };

  const handleClosePrice = () => {
    setshowPrice(false);
  };

  const getVouchersData = async () => {
    let product_id_array = cartItems.map((item: any) => item.product_id);
    //console.log("product_id_array", product_id_array, backendUrl);
    try {
      const orderValue =
        feesShow === false
          ? totalValue
          : Number(
              (totalValue ?? 0) - (pickupFees ? parseFloat(pickupFees) : 0)
            );
      let url = `${backendUrl}api/v2/voucher/get-order-and-item-voucher?total_cart_value=${orderValue}&product_id_array=[${product_id_array}]&user_id=${user_id}`;
      const response = await fetch(url,  {  method: 'GET',
        headers:{
          // Accept:'aplication/json',
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
  
        },
        credentials: "include",
        mode:"cors"          
      });


      const data = await response.json();
      if (response.ok) {
        //console.log("vouchers data:", data.data);
        setVouchersData(data.data);
        if (data.data.length > 0) {
          return data.data;
        } else {
          return data.data;
        }
      } else {

        if (!response.ok) {
          //console.error("Error fetching cart items:", response.status, response.statusText);
          
          // Handle 403 Forbidden explicitly
          if (response.status === 403) {
             
            localStorage.clear()
            sessionStorage.clear()
            setCartQuantity(0)
            setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/sell-used-appliances");
            }, 3000);
            return;
          }
    
          // throw new Error(`HTTP error! Status: ${response.status}`);
        }
        //console.error("Error fetching vouchers data:", data);
      }
    } catch (err) {
      //console.log("errrrrr", err);
    }
  };
  const setSelectedSessionStorageVoucher = (selectedVoucher: any) => {
    sessionStorage.setItem(
      "sessionSelectedVoucher",
      JSON.stringify(
        selectedVoucher.length === 0
          ? []
          : selectedVoucher.map((v: any) => v.voucher_id)
      )
    );
  };
  const setSessionAppliedCartItemVoucherRemove = (cart_item_id: any) => {
    let sessionAppliedRemoveCartVoucher = sessionStorage.getItem(
      "sessionAppliedRemoveCartItemVoucher"
    );
    if (sessionAppliedRemoveCartVoucher) {
      let appliedRemoveCartVoucher = JSON.parse(
        sessionAppliedRemoveCartVoucher
      );
      if (!appliedRemoveCartVoucher.includes(cart_item_id)) {
        appliedRemoveCartVoucher.push(cart_item_id);
      }
      sessionStorage.setItem(
        "sessionAppliedRemoveCartItemVoucher",
        JSON.stringify(appliedRemoveCartVoucher)
      );
    } else {
      let data = [cart_item_id];
      sessionStorage.setItem(
        "sessionAppliedRemoveCartItemVoucher",
        JSON.stringify(data)
      );
    }
  };

  const handleClose = () => {
    if (!applyVoucherButton) {
      setSelectedVouchers([]);
    }
    setVoucherPopupVisible(false);
    setItemOrOrderVoucherSelectionError("");
  };

  const handleVoucherSelection = (voucher: any) => {
    let orderLevelVoucher = 1;
    let itemLevelVoucher = 2;
    if (orderLevelVoucher === voucher.depends_on) {
      if (selectedVouchers.length === 0) {
        setSelectedVouchers([...selectedVouchers, voucher]);
      } else {
        let checkVocherStatus = checkOrderAndItemLevelVoucher(true, false);
        if (checkVocherStatus) {
          setItemOrOrderVoucherSelectionError(
            "Item voucher selected already. Please deselect the item voucher and then select order voucher"
          );
          return;
        } else {
          let duplicateVoucher = checkOrderLevelVoucherDuplicate();
          if (duplicateVoucher.length > 0) {
            if (duplicateVoucher[0].voucher_id === voucher.voucher_id) {
              setSelectedVouchers(
                selectedVouchers.filter(
                  (v: any) => v.voucher_id !== voucher.voucher_id
                )
              );
            } else {
              setSelectedVouchers([
                ...selectedVouchers.filter(
                  (v: any) => v.depends_on !== orderLevelVoucher
                ),
                voucher,
              ]);
            }
          } else {
            setSelectedVouchers(
              selectedVouchers.filter(
                (v: any) => v.voucher_id !== voucher.voucher_id
              )
              // [voucher.identifier]
            );
          }
        }
      }
      setItemOrOrderVoucherSelectionError("");
    } else if (itemLevelVoucher === voucher.depends_on) {
      // console.log(
      //   "Order voucher selected already. Please deselect the order voucher and then select item voucher"
      // );
      if (selectedVouchers.length === 0) {
        setSelectedVouchers([...selectedVouchers, voucher]);
      } else {
        let checkItemLevelVocherStatus = checkOrderAndItemLevelVoucher(
          false,
          true
        );
        // console.log(
        //   "Order voucher selected already. else",
        //   checkItemLevelVocherStatus
        // );
        if (checkItemLevelVocherStatus) {
          setItemOrOrderVoucherSelectionError(
            "Order voucher selected already. Please deselect the order voucher and then select item voucher"
          );
          return;
        } else {
          let voucherId: any = checkItemLevelVoucherProductIdDuplicate(voucher);
          // console.log(
          //   "voucherId",
          //   voucherId,
          //   "voucher",
          //   voucher,
          //   "itemVoucher"
          // );
          if (voucherId.status) {
            if (voucherId.voucher_id === voucher.voucher_id) {
              setSelectedVouchers([
                ...selectedVouchers.filter(
                  (v: any) => v.voucher_id !== voucherId.voucher_id
                ),
              ]);
            } else {
              // console.log(
              //   "checkDisabledVoucherData()",
              //   checkDisabledVoucherData(voucherId.voucher_id)
              // );
              if (checkDisabledVoucherData(voucherId.voucher_id)) {
                setItemOrOrderVoucherSelectionError(
                  "Same voucher is already used. Please remove the same product voucher."
                );
                return;
              }
              setSelectedVouchers([
                ...selectedVouchers.filter(
                  (v: any) => v.voucher_id !== voucherId.voucher_id
                ),
                voucher,
              ]);
              // appliedVoucherWithPerticularCartItem(voucher);
            }
          } else {
            let itemVoucher = selectedVouchers.find(
              (vo: any) => vo.voucher_id === voucher.voucher_id
            );
            //console.log("itemVoucher",itemVoucher,voucher,selectedVouchers);
            if (itemVoucher && itemVoucher.voucher_id === voucher.voucher_id) {
              setSelectedVouchers(
                selectedVouchers.filter(
                  (v: any) => v.voucher_id !== voucher.voucher_id
                )
              );
            } else {
              setSelectedVouchers([...selectedVouchers, voucher]);
            }
          }
        }
      }
      setItemOrOrderVoucherSelectionError("");
    }
    // setApplyVoucherButton(false)
    //console.log("selected vouchers:", selectedVouchers);
  };
  const checkDisabledVoucherData = (voucher_id: any) => {
    let disabledVoucher = appliedDummyVoucherData.find(
      (v: any) => v.voucher_id === voucher_id
    );
    return disabledVoucher ? true : false;
  };

  const checkItemLevelVoucherProductIdDuplicate = (voucher: any) => {
    let product_id_array: any = voucher.apply_condition?.split(",");

    let check: any = { status: false, voucher_id: null };
    for (let i = 0; i < product_id_array.length; i++) {
      for (let j = 0; j < selectedVouchers.length; j++) {
        let sele_product_id_array =
          selectedVouchers[j].apply_condition?.split(",");
        if (sele_product_id_array.includes(product_id_array[i])) {
          check = { status: true, voucher_id: selectedVouchers[j].voucher_id };
          break;
        }
      }
      if (check.status) {
        break;
      }
    }
    //console.log("voucher_id check duplicate", check);
    return check;
  };
  const checkOrderLevelVoucherDuplicate = () => {
    let selectedvoucher: any = selectedVouchers.filter(
      (vo: any) => vo.depends_on === 1
    );
    return selectedvoucher;
  };

  const checkOrderAndItemLevelVoucher = (
    orderLevel: boolean,
    itemLevel: boolean
  ) => {
    //console.log("item----order--level------", orderLevel, itemLevel);
    if (orderLevel) {
      for (let i = 0; i < selectedVouchers.length; i++) {
        let voucher: any = vouchersData.find(
          (vo: any) => vo.voucher_id === selectedVouchers[i].voucher_id
        );
        if (voucher.depends_on === 2) {
          return true;
        }
      }
      return false;
    } else if (itemLevel) {
      for (let i = 0; i < selectedVouchers.length; i++) {
        let voucher: any = vouchersData.find(
          (vo: any) => vo.voucher_id === selectedVouchers[i].voucher_id
        );
        //console.log("--true-----item---", voucher);
        if (voucher.depends_on == 1) {
          return true;
        }
      }
      return false;
    }
  };

  const applyVoucher = () => {
    // let appliedVoucher: any = {}
    // selectedVouchers.forEach((v: any) => {
    //   let voucher: any = vouchersData.find((vo: any) => vo.identifier === v && voucher.depends_on === 2)
    //   if (voucher) {
    //     // appliedVoucher["vou"]
    //   }
    // })
    //console.log("apply voucher data", selectedVouchers);
    if (selectedVouchers.length > 0) {
      let appliedVoucher = appliedVoucherWithPerticularCartItem(
        selectedVouchers,
        false
      );
      setAppliedCartItemVoucher(appliedVoucher);
      setAppliedDummyVoucherData([...selectedVouchers]);
      setSelectedSessionStorageVoucher([...selectedVouchers]);
      checkPickupFeesWaivedFromAddVoucher(appliedVoucher);
      setVoucherPopupVisible(false);
      setApplyVoucherButton(true);
      // setCartItems([...cartItems])
    } else {
      setAppliedCartItemVoucher([]);
      setSelectedSessionStorageVoucher([...selectedVouchers]);
      checkPickupFeesWaivedFromAddVoucher([]);
      setVoucherPopupVisible(true);
      setApplyVoucherButton(false);
    }
    setItemOrOrderVoucherSelectionError("");
  };

  const appliedVoucherWithPerticularCartItem = (
    selectedSessionVoucher: any,
    applyButton = true
  ) => {
    // let sessionAppliedVoucher = sessionStorage.getItem("sessionAppliedVoucher");
    // if (sessionAppliedVoucher) {
    //   sessionAppliedVoucher = JSON.parse(sessionAppliedVoucher);
    //   return sessionAppliedVoucher
    // } else {
    let sessionAppliedRemoveCartVoucher: any = sessionStorage.getItem(
      "sessionAppliedRemoveCartItemVoucher"
    );
    if (sessionAppliedRemoveCartVoucher) {
      sessionAppliedRemoveCartVoucher = JSON.parse(
        sessionAppliedRemoveCartVoucher
      );
    }
    let appliedVoucher: any = [];
  
    selectedSessionVoucher.forEach((selV: any) => {
      cartItems.forEach((it: any) => {
        let product_id_array = selV.apply_condition?.split(",");
        if (product_id_array.includes(it.product_id.toString())) {
          if (sessionAppliedRemoveCartVoucher && applyButton) {
            let removeCartItem = sessionAppliedRemoveCartVoucher.filter(
              (itm: any) => itm === it.item_id
            );
            if (removeCartItem.length === 0) {
              appliedVoucher.push({
                product_id: it.product_id,
                voucher_id: selV.voucher_id,
                cart_item_id: it.item_id,
                voucher_value: selV.voucher_value,
              });
            }
          } else {
            appliedVoucher.push({
              product_id: it.product_id,
              voucher_id: selV.voucher_id,
              cart_item_id: it.item_id,
              voucher_value: selV.voucher_value,
            });
          }
        }
      });
    });

    return appliedVoucher;
    // }
  };

  const getAppliedVoucherData = () => {
    let appliedVouchers: any = [];
    for (let i = 0; i < selectedVouchers.length; i++) {
      let voucherLevel = selectedVouchers[i].depends_on;
      if (voucherLevel === 1) {
        let vourcherData = {
          voucher_id: selectedVouchers[i].voucher_id,
          product_id: null,
          orderLevelVoucher: true,
          itemLevelVoucher: false,
        };
        appliedVouchers.push(vourcherData);
        break;
      } else if (voucherLevel === 2) {
        // let product_id_array:any = selectedVouchers[i]?.apply_condition
        // if (product_id_array) {
        //   // product_id_array = product_id_array.split(",")
        //   cartItems.forEach((item: any) => {
        //       let checkDuplicate = appliedCartItemVoucher.find((voc: any) => voc.cart_item_id === item.item_id && )
        //       if (checkDuplicate == undefined) {
        //         let vourcherData = {
        //           voucher_id: selectedVouchers[i].voucher_id,
        //           product_id: item.product_id,
        //           orderLevelVoucher: false,
        //           itemLevelVoucher: true,
        //         };

        //         appliedVouchers.push(vourcherData);
        //       }

        //   })

        // }
        let data = appliedCartItemVoucher.filter(
          (d: any) => d.voucher_id === selectedVouchers[i].voucher_id
        );

        data.forEach((vo: any) =>
          appliedVouchers.push({
            voucher_id: selectedVouchers[i].voucher_id,
            product_id: vo.product_id,
            cart_item_id: vo.cart_item_id,
            orderLevelVoucher: false,
            itemLevelVoucher: true,
          })
        );
      }
    }
    return appliedVouchers;
  };

  const removeSelectedAllItemVoucher = (product_id: any, cart_item_id: any) => {
    let selectedVoucher = selectedVouchers.find((vo: any) => {
      let product_id_array = vo.apply_condition?.split(",");
      return product_id_array.includes(product_id.toString());
    });
    if (selectedVoucher?.voucher_id) {
      let data = selectedVouchers.filter(
        (v: any) => v.voucher_id !== selectedVoucher.voucher_id
      );
      let appliedVoucher = appliedCartItemVoucher.filter(
        (ct: any) => ct.voucher_id !== selectedVoucher?.voucher_id
      );
      appliedCartItemVoucher.forEach((v: any) => {
        if (v.voucher_id === selectedVoucher?.voucher_id) {
          setSessionAppliedCartItemVoucherRemove(v.cart_item_id);
        }
      });
      setAppliedCartItemVoucher(appliedVoucher);
      checkPickupFeesWaivedFromAddVoucher(appliedVoucher);

      //console.log("removeSelectedItemVoucher------->", data);
      if (data && data.length === 0 && selectedVouchers.length === 1) {
        setSelectedVouchers([]);
        setAppliedDummyVoucherData([]);
        setSelectedSessionStorageVoucher([]);
        setApplyVoucherButton(false);
      } else if (data && data.length > 0) {
        //console.log("else if enter");
        setSelectedVouchers(data);
        setAppliedDummyVoucherData(data);
        setSelectedSessionStorageVoucher(data);
      }
    }
  };

  const removeVoucherPerItemSuccess = () => {
    let data = appliedCartItemVoucher.filter(
      (v: any) =>
        v.product_id === removeVoucherPerItemData.product_id ||
        v.voucher_id === removeVoucherPerItemData.voucher_id
    );
    if (data.length > 1) {
      setRemoveAllItemLevelVoucherPopUpStatus(true);
      setRemoveItemLevelVoucherPopUpStatus(false);
    } else {
      removeSelectedSingleItemVoucher(
        removeVoucherPerItemData.product_id,
        removeVoucherPerItemData.cart_item_id
      );
      setRemoveItemLevelVoucherPopUpStatus(false);
    }
  };

  const checkPickupFeesWaivedFromAddVoucher = (appliedVoucher: any) => {
    setVoucherValueStatus(false);
    if (cartItems.length === appliedVoucher.length) {
      setPickupFeesAppliedVoucherStatus(true);
      handleValueOfCash(appliedVoucher, true);
      return true;
    } else {
      setPickupFeesAppliedVoucherStatus(false);
      handleValueOfCash(appliedVoucher, false);
      return false;
    }
  };

  const handleValueOfCash = (appliedVoucher: any, voucherStatus: boolean) => {
    if (voucherStatus) {
      setCashValueStatus(false);
      // setCashValueAmount(0);
      setCashValueAmount(
        calculateCashValueAmount(appliedVoucher, voucherStatus)
      );
    } else {
      setCashValueStatus(true);
      if (appliedVoucher.length > 0) {
        setCashValueAmount(
          calculateCashValueAmount(appliedVoucher, voucherStatus)
        );
      } else {
        setCashValueAmount(
          calculateCashValueAmount(appliedVoucher, voucherStatus)
        );
      }
    }
  };
  const calculateCashValueAmount = (
    appliedVoucher: any,
    voucherStatus: boolean
  ) => {
    let cash = 0;
    let voucherValue = 0;
    cartItems.forEach((item: any) => {
      let appliedVoucherdata = appliedVoucher.filter(
        (i: any) => i.cart_item_id === item.item_id
      );
      // //console.log(
      //   "pickup fesss amount data------------>",
      //   appliedCartItemVoucher,
      //   appliedVoucherdata,
      //   item.item_id
      // );
      
      if (appliedVoucherdata.length === 0) {
        cash += parseFloat(item.base_value) * item.quantity;
        // voucherStatus
        //   ? parseFloat(item.base_value) * item.quantity
        //   : parseFloat(item.base_value) * item.quantity -
        //    (pickupFees && feesShow ? Number(pickupFees):0);
      }

      if (appliedVoucherdata.length > 0) {
        voucherValue += parseFloat(appliedVoucherdata[0].voucher_value);
      }
    });
    // //console.log(
    //   "cash += parseFloat(item.base_value) * item.quantity;--------------------------------------------------->",
    //   cash,
    //   voucherValue
    // );
    setVoucherValueStatus(true);
    setVoucherValueAmount(voucherValue);
    // cash -= voucherStatus ? 0 : feesShow == false ? 0 : pickupFees? Number(pickupFees): 0
    return cash;
  };

  useEffect(() => {
    if (voucherPopupVisible) {
      document.body.style.overflow = "hidden"; // Disable background scroll
    } else {
      document.body.style.overflow = ""; // Re-enable background scroll
    }

    // Cleanup function to reset scroll on component unmount
    return () => {
      document.body.style.overflow = "";
    };
  }, [voucherPopupVisible]);

  let voucherMoreterms = [
    "Update your registered email to Flash.co email ID",
    "Offer valid on select payment methods",
    "Applicable on net transaction amount of ₹200",
    "Not valid for orders containing Swiggy Lite membership",
    "Cashback will be credited to Swiggy Money in 14 business days.",
    "Offer valid till Dec 31, 2024, 11:59 PM",
  ];
  const getApplyVoucherValue = () => {
    let value = selectedVouchers
      .map((s: any) => {
        if (s.identifier.length > 4) {
          return s.identifier;
        } else {
          return s.identifier;
        }
      })
      .join(" ,");

    return value;
  };
  const modalStyles: {
    overlay: React.CSSProperties;
    modal: React.CSSProperties;
    button: React.CSSProperties;
  } = {
    overlay: {
      position: "fixed", // Valid string for 'position'
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    modal: {
      backgroundColor: "white",
      padding: "40px",
      borderRadius: "8px",
      textAlign: "center",
    },
    button: {
      padding: "5px",
      margin: "8px",
    },
  };

  return (
    <div>
      {/* {isLoading && <div className="blurr-body"></div>} */}
      <Header />
      {showFlashMessage && <FlashMessage message={error ?? ""} onClose={() => setShowFlashMessage(false)} />}

      <div className="section_breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li
                  className="breadcrumb-item"
                >
                 <a href="/sell-used-appliances">Sell Now</a> 
                </li>
                <li className="breadcrumb-item" aria-current="page">
                  <a href="/cart/listing">My Recycle Cart</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <a>Order Checkout</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loader"></div>
        </div>
      )}

      <section className="recycle_cart">
        <div className="container">
          <h2 className="text-center mb-4">Checkout Details</h2>

          <div className="row">
            <div className="col-lg-8">
              <div className="delivery_address">
                <h5 className="mb-3">1. Select a pickup address</h5>

                {addresses.length === 0 ? (
                  <div className="empty-cart-add-new">
                    <form className="mt-4" onSubmit={handleSubmit}>
                      <div className="row g-3">
                        {/* <div> */}
                        <div className="col-md-6">
                          <label htmlFor="address_1">
                            Address 1<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            id="address_1"
                            name="address_1"
                            className="form-new-address"
                            placeholder="Enter Address 1"
                            value={addressAdd.address_1}
                            onChange={handleInputChange}
                            maxLength={50}
                            required
                            onInvalid={(e) => {
                              const target = e.target as HTMLInputElement;
                              if (!target.value) {
                                target.setCustomValidity(
                                  "Address is required."
                                );
                              } else if (!/[a-zA-Z0-9]+/.test(target.value)) {
                                target.setCustomValidity(
                                  "Address must contain at least one letter or number."
                                );
                              }
                            }}
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement;
                              target.setCustomValidity(""); // Clear error message
                            }}
                          />
                          {globalAddressErrors.address_1_error_status && (
                            <span className="error-message-pincode-update">
                              {globalAddressErrors.address_1}
                            </span>
                          )}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="address_2">
                            Address 2<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            id="address_2"
                            name="address_2"
                            placeholder="Enter Address 2"
                            className="form-new-address"
                            value={addressAdd.address_2}
                            onChange={handleInputChange}
                            required
                            maxLength={50}
                            onInvalid={(e) => {
                              const target = e.target as HTMLInputElement;
                              if (!target.value) {
                                target.setCustomValidity(
                                  "Address is required."
                                );
                              } else if (target.value.length < 2) {
                                // target.setCustomValidity("Address must be at least 2 characters long.");
                              }
                            }}
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement;
                              target.setCustomValidity(""); // Clear error message
                            }}
                          />
                          {globalAddressErrors.address_2_error_status && (
                            <span className="error-message-pincode-update">
                              {globalAddressErrors.address_2}
                            </span>
                          )}
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="landmark">Landmark</label>
                          <input
                            type="text"
                            id="landmark"
                            name="landmark"
                            className="form-new-address"
                            placeholder="Enter Landmark"
                            maxLength={50}
                            value={addressAdd.landmark}
                            onChange={handleInputChange}
                          />
                          {globalAddressErrors.landmark_error_status && (
                            <span className="error-message-pincode-update">
                              {globalAddressErrors.landmark}
                            </span>
                          )}
                        </div>
                        {/* </div> */}

                        <div className="col-md-6">
                          <label htmlFor="pincode">
                            Pincode<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            id="pincode"
                            name="pincode"
                            className="form-new-address"
                            placeholder="Enter Pincode"
                            value={addressAdd.pincode || ""}
                            onChange={handlePincodeChange}
                            required
                            min="0"
                            max="999999"
                            onInvalid={(e) => {
                              const target = e.target as HTMLInputElement; // Cast to HTMLInputElement
                              target.setCustomValidity(
                                "Please enter a valid 6-digit pincode."
                              );
                            }}
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement; // Cast to HTMLInputElement
                              target.setCustomValidity(""); // Reset error message
                            }}
                          />
                          <span
                            className="error-message-pincode-update"
                            style={{
                              display:
                                addressAdd.pincode &&
                                addressAdd.pincode.length < 6
                                  ? "block"
                                  : "none",
                            }}
                          >
                            Pincode must be exactly 6 digits.
                          </span>
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="state">
                            State<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            id="state"
                            name="state"
                            className="form-new-address"
                            placeholder="State"
                            value={addressAdd.state}
                            onChange={handleInputChange}
                            required
                            disabled
                          />
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="city">
                            City<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            id="city"
                            name="city"
                            className="form-new-address"
                            placeholder="City"
                            value={addressAdd.city}
                            onChange={handleInputChange}
                            required
                            disabled
                          />
                        </div>
                      </div>
                      {/* <button type="submit">Add New Address</button> */}
                    </form>
                  </div>
                ) : (
                  <div>
                    {addresses.map((address) => (
                      <label key={address.address_id}>
                        <div
                          className="card delivery-address"
                          style={{
                            border:
                              selectedAddressId === address.address_id
                                ? "1px solid green"
                                : "1px solid #ccc",
                            padding: "10px",
                            borderRadius: "5px",
                            transition: "border-color 0.3s ease",
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex flex-wrap">
                              <input
                                type="radio"
                                name="selectedAddress"
                                value={address.address_id}
                                checked={
                                  selectedAddressId === address.address_id
                                }
                                // onChange={handleAddressChange}
                                onChange={(event) => {
                                  handleAddressChange(event);
                                }}
                              />

                              <p className=" address_txt mb-0">
                                {" "}
                                {address.address_1} {address.address_2}{" "}
                                {address.landmark} {address.city} (
                                {address.pincode}){address.state_id}
                              </p>
                            </div>

                            <i
                              className="fas fa-pen edit-icon"
                              onClick={() => {
                                setShowPopupAddress(address.address_id);
                                setNewAddress({
                                  address_1: address.address_1,
                                  address_2: address.address_2,
                                  landmark: address.landmark,
                                  city: address.city,
                                  state: address.state_id,
                                  pincode: address.pincode,
                                  state_id: address.state_id,
                                });
                              }}
                            ></i>
                            {showPopupAddress === address.address_id && (
                              <div className="popup">
                                <div className="popup-content">
                                  <div
                                    className="edit_address "
                                    id="exampleModal"
                                    tabIndex={-1}
                                    aria-labelledby="exampleModalLabel"
                                    aria-hidden="true"
                                    // id="exampleModal"
                                    // tabIndex={-1}
                                    // aria-labelledby="exampleModalLabel"
                                    // aria-hidden="true"
                                  >
                                    <div className="modal-dialog modal-dialog-centered modal-lg">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h1
                                            className="modal-title fs-5"
                                            id="exampleModalLabel"
                                          >
                                            Update Address
                                          </h1>
                                          <button
                                            className="close-button"
                                            onClick={() => {
                                              setShowPopupAddress(null);
                                              setNewAddress({
                                                address_1: "",
                                                address_2: "",
                                                landmark: "",
                                                city: "",
                                                state: "",
                                                pincode: "",
                                                state_id: "",
                                              });
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faTimes} />
                                          </button>
                                        </div>
                                        <div className="modal-body">
                                          <form
                                            className="mt-4"
                                            onSubmit={(e) =>
                                              handleUpdateAddressSubmit(
                                                e,
                                                address.address_id
                                              )
                                            }
                                          >
                                            <div className="row g-3">
                                              <div className="col-md-6">
                                                <label htmlFor="address_1">
                                                  Address 1
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    *
                                                  </span>
                                                </label>
                                                <input
                                                  type="text"
                                                  id="address_1"
                                                  name="address_1"
                                                  className="form-control"
                                                  placeholder="Enter Address 1"
                                                  value={addressAdd.address_1}
                                                  onChange={handleInputChange}
                                                  maxLength={50}
                                                  required
                                                  onInvalid={(e) => {
                                                    const target =
                                                      e.target as HTMLInputElement;
                                                    if (!target.value) {
                                                      target.setCustomValidity(
                                                        "Address is required."
                                                      );
                                                    } else if (
                                                      target.value.length < 2
                                                    ) {
                                                      // target.setCustomValidity("Address must be at least 2 characters long.");
                                                    }
                                                  }}
                                                  onInput={(e) => {
                                                    const target =
                                                      e.target as HTMLInputElement;
                                                    target.setCustomValidity(
                                                      ""
                                                    ); // Clear error message
                                                  }}
                                                />

                                                {globalAddressErrors.address_1_error_status && (
                                                  <span className="error-message-pincode-update">
                                                    {
                                                      globalAddressErrors.address_1
                                                    }
                                                  </span>
                                                )}
                                              </div>

                                              <div className="col-md-6">
                                                <label htmlFor="address_2">
                                                  Address 2
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    *
                                                  </span>
                                                </label>
                                                <input
                                                  type="text"
                                                  id="address_2"
                                                  name="address_2"
                                                  className="form-control"
                                                  placeholder="Enter Address 2"
                                                  value={addressAdd.address_2}
                                                  onChange={handleInputChange}
                                                  required
                                                  maxLength={50}
                                                  onInvalid={(e) => {
                                                    const target =
                                                      e.target as HTMLInputElement;
                                                    if (!target.value) {
                                                      target.setCustomValidity(
                                                        "Address is required."
                                                      );
                                                    } else if (
                                                      target.value.length < 2
                                                    ) {
                                                      // target.setCustomValidity("Address must be at least 2 characters long.");
                                                    }
                                                  }}
                                                  onInput={(e) => {
                                                    const target =
                                                      e.target as HTMLInputElement;
                                                    target.setCustomValidity(
                                                      ""
                                                    ); // Clear error message
                                                  }}
                                                />

                                                {globalAddressErrors.address_2_error_status && (
                                                  <span className="error-message-pincode-update">
                                                    {
                                                      globalAddressErrors.address_2
                                                    }
                                                  </span>
                                                )}
                                              </div>

                                              <div className="col-md-6">
                                                <label htmlFor="landmark">
                                                  Landmark
                                                </label>
                                                <input
                                                  type="text"
                                                  id="landmark"
                                                  name="landmark"
                                                  className="form-control"
                                                  placeholder="Enter Landmark"
                                                  maxLength={50}
                                                  value={addressAdd.landmark}
                                                  onChange={handleInputChange}
                                                />
                                                {globalAddressErrors.landmark_error_status && (
                                                  <span className="error-message-pincode-update">
                                                    {
                                                      globalAddressErrors.landmark
                                                    }
                                                  </span>
                                                )}
                                              </div>
                                              <div className="col-md-6">
                                                <label htmlFor="pincode">
                                                  Pincode
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    *
                                                  </span>
                                                </label>
                                                <input
                                                  type="number"
                                                  id="pincode"
                                                  name="pincode"
                                                  className="form-control"
                                                  placeholder="Enter Pincode"
                                                  value={
                                                    addressAdd.pincode || ""
                                                  }
                                                  onChange={handlePincodeChange}
                                                  required
                                                  min="0"
                                                  max="999999"
                                                  onInvalid={(e) => {
                                                    const target =
                                                      e.target as HTMLInputElement; // Cast to HTMLInputElement
                                                    target.setCustomValidity(
                                                      "Please enter a valid 6-digit pincode."
                                                    );
                                                  }}
                                                  onInput={(e) => {
                                                    const target =
                                                      e.target as HTMLInputElement; // Cast to HTMLInputElement
                                                    target.setCustomValidity(
                                                      ""
                                                    ); // Reset error message
                                                  }}
                                                />
                                                <span
                                                  className="error-message-pincode-update"
                                                  style={{
                                                    display:
                                                      addressAdd.pincode &&
                                                      addressAdd.pincode
                                                        .length < 6
                                                        ? "block"
                                                        : "none",
                                                  }}
                                                >
                                                  Pincode must be exactly 6
                                                  digits.
                                                </span>
                                                {pinServiceableMessage.length >
                                                  0 &&
                                                  pinServiceableStatus && (
                                                    <span className="error-message-pincode-update">
                                                      {pinServiceableMessage}
                                                    </span>
                                                  )}
                                              </div>

                                              <div className="col-md-6">
                                                <label htmlFor="state">
                                                  State
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    *
                                                  </span>
                                                </label>
                                                <input
                                                  type="text"
                                                  id="state"
                                                  name="state"
                                                  className="form-control"
                                                  placeholder="State"
                                                  value={
                                                    addressAdd?.state
                                                      ? addressAdd?.state
                                                      : ""
                                                  }
                                                  onChange={handleInputChange}
                                                  required
                                                  disabled
                                                />
                                              </div>

                                              <div className="col-md-6">
                                                <label htmlFor="city">
                                                  City
                                                  <span
                                                    style={{ color: "red" }}
                                                  >
                                                    *
                                                  </span>
                                                </label>
                                                <input
                                                  type="text"
                                                  id="city"
                                                  name="city"
                                                  className="form-control"
                                                  placeholder="City"
                                                  value={addressAdd.city}
                                                  onChange={handleInputChange}
                                                  required
                                                  disabled
                                                />
                                              </div>

                                              <button
                                                type="submit"
                                                disabled={!isFormValid()}
                                              >
                                                Update Address
                                              </button>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </label>
                    ))}
                    <button
                      className=" add_address_btn btn btn-success"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      Add new address
                    </button>
                  </div>
                )}

                {/* Popup modal for adding new address */}

                <div
                  className="modal fade edit_address"
                  id="exampleModal"
                  tabIndex={-1}
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                          Address Details
                        </h1>
                        <button
                          className="close-button btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      </div>
                      <div className="modal-body">
                        <form
                          className="mt-4"
                          onSubmit={handleSubmitAddressOnModal}
                        >
                          <div className="row g-3">
                            <div className="col-md-6">
                              <label htmlFor="address_1">
                                Address 1<span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                id="address_1"
                                name="address_1"
                                className="form-control"
                                placeholder="Enter Address 1"
                                value={addressAdd.address_1}
                                onChange={(e) => {
                                  handleInputChange(e);
                                  validateAddress(e.target.value);
                                }}
                                maxLength={50}
                                required
                                onInvalid={(e) => {
                                  const target = e.target as HTMLInputElement;
                                  if (!target.value) {
                                    target.setCustomValidity(
                                      "Address is required."
                                    );
                                  } else if (target.value.length < 2) {
                                    // target.setCustomValidity("Address must be at least 2 characters long.");
                                  }
                                }}
                                onInput={(e) => {
                                  const target = e.target as HTMLInputElement;
                                  target.setCustomValidity(""); // Clear error message
                                }}
                              />
                              {globalAddressErrors.address_1_error_status && (
                                <span className="error-message-pincode-update">
                                  {globalAddressErrors.address_1}
                                </span>
                              )}
                            </div>

                            <div className="col-md-6">
                              <label htmlFor="address_2">
                                Address 2<span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                id="address_2"
                                name="address_2"
                                className="form-control"
                                placeholder="Enter Address 2"
                                value={addressAdd.address_2}
                                onChange={handleInputChange}
                                required
                                maxLength={50}
                                onInvalid={(e) => {
                                  const target = e.target as HTMLInputElement;
                                  if (!target.value) {
                                    target.setCustomValidity(
                                      "Address is required."
                                    );
                                  } else if (target.value.length < 2) {
                                    // target.setCustomValidity("Address must be at least 2 characters long.");
                                  }
                                }}
                                onInput={(e) => {
                                  const target = e.target as HTMLInputElement;
                                  target.setCustomValidity(""); // Clear error message
                                }}
                              />

                              {globalAddressErrors.address_2_error_status && (
                                <span className="error-message-pincode-update">
                                  {globalAddressErrors.address_2}
                                </span>
                              )}
                            </div>

                            <div className="col-md-6">
                              <label htmlFor="landmark">Landmark</label>
                              <input
                                type="text"
                                id="landmark"
                                name="landmark"
                                className="form-control"
                                placeholder="Enter Landmark"
                                maxLength={50}
                                value={addressAdd.landmark}
                                onChange={handleInputChange}
                              />
                              {globalAddressErrors.landmark_error_status && (
                                <span className="error-message-pincode-update">
                                  {globalAddressErrors.landmark}
                                </span>
                              )}
                            </div>

                            <div className="col-md-6">
                              <label htmlFor="pincode">
                                Pincode<span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                id="pincode"
                                name="pincode"
                                className="form-control"
                                placeholder="Enter Pincode"
                                value={addressAdd.pincode || ""}
                                onChange={handlePincodeChange}
                                required
                                min="0"
                                max="999999"
                                onInvalid={(e) => {
                                  const target = e.target as HTMLInputElement; // Cast to HTMLInputElement
                                  target.setCustomValidity(
                                    "Please enter a valid 6-digit pincode."
                                  );
                                }}
                                onInput={(e) => {
                                  const target = e.target as HTMLInputElement; // Cast to HTMLInputElement
                                  target.setCustomValidity(""); // Reset error message
                                }}
                              />
                              <span
                                className="error-message-pincode-update"
                                style={{
                                  display:
                                    addressAdd.pincode &&
                                    addressAdd.pincode.length < 6
                                      ? "block"
                                      : "none",
                                }}
                              >
                                Pincode must be exactly 6 digits.
                              </span>
                              {pinServiceableMessage.length > 0 &&
                                pinServiceableStatus && (
                                  <span className="error-message-pincode-update">
                                    {pinServiceableMessage}
                                  </span>
                                )}
                            </div>

                            <div className="col-md-6">
                              <label htmlFor="state">
                                State<span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                id="state"
                                name="state"
                                className="form-control"
                                placeholder="State"
                                value={addressAdd.state}
                                onChange={handleInputChange}
                                required
                                disabled
                              />
                            </div>

                            <div className="col-md-6">
                              <label htmlFor="city">
                                City<span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                id="city"
                                name="city"
                                className="form-control"
                                placeholder="City"
                                value={addressAdd.city}
                                onChange={handleInputChange}
                                required
                                disabled
                              />
                            </div>

                            <div className="mt-4">
                              <button
                                type="submit"
                                className="btn btn-success"
                                disabled={!isFormValid()}
                              >
                                Add Address
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                {showPopup && (
                  <div className="popup">
                    <div className="popup-content">
                      <div
                        className="edit_address "
                        id="exampleModal"
                        tabIndex={-1}
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h1
                                className="modal-title fs-5"
                                id="exampleModalLabel"
                              >
                                Address Details
                              </h1>
                              <button
                                className="close-button"
                                onClick={() => setShowPopup(false)}
                              >
                                <FontAwesomeIcon icon={faTimes} />
                              </button>
                            </div>
                            <div className="modal-body">
                              <form
                                className="mt-4"
                                onSubmit={handleSubmitAddressOnModal}
                              >
                                <div className="row g-3">
                                  <div className="col-md-6">
                                    <label htmlFor="address_1">
                                      Address 1
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      id="address_1"
                                      name="address_1"
                                      className="form-control"
                                      placeholder="Enter Address 1"
                                      value={addressAdd.address_1}
                                      onChange={(e) => {
                                        handleInputChange(e);
                                        validateAddress(e.target.value);
                                      }}
                                      maxLength={50}
                                      required
                                      onInvalid={(e) => {
                                        const target =
                                          e.target as HTMLInputElement;
                                        if (!target.value) {
                                          target.setCustomValidity(
                                            "Address is required."
                                          );
                                        } else if (target.value.length < 2) {
                                          // target.setCustomValidity("Address must be at least 2 characters long.");
                                        }
                                      }}
                                      onInput={(e) => {
                                        const target =
                                          e.target as HTMLInputElement;
                                        target.setCustomValidity(""); // Clear error message
                                      }}
                                    />
                                  </div>

                                  <div className="col-md-6">
                                    <label htmlFor="address_2">
                                      Address 2
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      id="address_2"
                                      name="address_2"
                                      className="form-control"
                                      placeholder="Enter Address 2"
                                      value={addressAdd.address_2}
                                      onChange={handleInputChange}
                                      required
                                      maxLength={50}
                                      onInvalid={(e) => {
                                        const target =
                                          e.target as HTMLInputElement;
                                        if (!target.value) {
                                          target.setCustomValidity(
                                            "Address is required."
                                          );
                                        } else if (target.value.length < 2) {
                                          // target.setCustomValidity("Address must be at least 2 characters long.");
                                        }
                                      }}
                                      onInput={(e) => {
                                        const target =
                                          e.target as HTMLInputElement;
                                        target.setCustomValidity(""); // Clear error message
                                      }}
                                    />
                                  </div>

                                  <div className="col-md-6">
                                    <label htmlFor="landmark">Landmark</label>
                                    <input
                                      type="text"
                                      id="landmark"
                                      name="landmark"
                                      className="form-control"
                                      placeholder="Enter Landmark"
                                      value={addressAdd.landmark}
                                      onChange={handleInputChange}
                                    />
                                  </div>

                                  <div className="col-md-6">
                                    <label htmlFor="pincode">
                                      Pincode
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="number"
                                      id="pincode"
                                      name="pincode"
                                      className="form-control"
                                      placeholder="Enter Pincode"
                                      value={addressAdd.pincode || ""}
                                      onChange={handlePincodeChange}
                                      required
                                      min="0"
                                      max="999999"
                                      onInvalid={(e) => {
                                        const target =
                                          e.target as HTMLInputElement; // Cast to HTMLInputElement
                                        target.setCustomValidity(
                                          "Please enter a valid 6-digit pincode."
                                        );
                                      }}
                                      onInput={(e) => {
                                        const target =
                                          e.target as HTMLInputElement; // Cast to HTMLInputElement
                                        target.setCustomValidity(""); // Reset error message
                                      }}
                                    />
                                    <span
                                      className="error-message-pincode-update"
                                      style={{
                                        display:
                                          addressAdd.pincode &&
                                          addressAdd.pincode.length < 6
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      Pincode must be exactly 6 digits.
                                    </span>
                                    {pinServiceableMessage.length > 0 &&
                                      pinServiceableStatus && (
                                        <span className="error-message-pincode-update">
                                          {pinServiceableMessage}
                                        </span>
                                      )}
                                  </div>

                                  <div className="col-md-6">
                                    <label htmlFor="state">
                                      State
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      id="state"
                                      name="state"
                                      className="form-control"
                                      placeholder="State"
                                      value={addressAdd.state}
                                      onChange={handleInputChange}
                                      required
                                      disabled
                                    />
                                  </div>

                                  <div className="col-md-6">
                                    <label htmlFor="city">
                                      City
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      id="city"
                                      name="city"
                                      className="form-control"
                                      placeholder="City"
                                      value={addressAdd.city}
                                      onChange={handleInputChange}
                                      required
                                      disabled
                                    />
                                  </div>

                                  <div className="mt-4">
                                    <button
                                      type="submit"
                                      className="btn btn-success"
                                    >
                                      Add Address
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="picker_sec">
                <h5>2. Pickup Schedule</h5>
                <DatePicker
                  id="date-input"
                  ref={datePickerRef}
                  placeholderText="DD-MM-YYYY"
                  selected={pickupSlotDate}
                  onChange={(date: any) => {
                    let formatDate = new Date(
                      new Date(date).setDate(new Date(date).getDate() + 1)
                    )
                      .toISOString()
                      .split("T")[0];
                   
                    if (formatDate.split("-")[0] === "1970") {
                     
                      setPickupSlotDate(null);
                      setSelectPickupSlotDate(null);
                    } else {
                      setPickupSlotDate(date);
                      setSelectPickupSlotDate(formatDate);
                    }
                    setPickupDateSelectError(null);
                  }} // Set selected date
                  filterDate={isPickupDateAllowed} // Enable only allowed dates
                  dateFormat="dd-MM-yyyy" // Date format
                  onCalendarOpen={fetchSelectPickupSlotDate}
                  onKeyDown={(e) => e.preventDefault()} // Prevent typing in the input field
                  isClearable
                  customInput={<input readOnly/>}
                />
                {pickupDateSelectError && (
                  <span className="error-message-pincode-update">
                    {pickupDateSelectError}
                  </span>
                )}
              </div>
              <div className="review_items mt-5" key={refreshPriceKey}>
                <h5>3. Review items</h5>
                {/* <p className="sub_title">Items for Pickup :</p> */}
                {cartItems.length === 0 && !buyNowProduct ? (
                  <div className="empty-cart-message">
                    {/* <p>Loading...</p> */}
                    <div className="loader"></div>{" "}
                    {/* Add your loader component or animation here */}
                  </div>
                ) : (
                  <div>
                    {/* Render Cart Items */}
                    {cartItems.map((item: any) => (
                      <div key={item.product_id}>
                        <div className="card">
                          <div className="d-flex align-items-center">
                            <div className="pickup_item_img">
                              {/* <img
                                src={ProductImage}
                                alt={item.title}
                                className="product-img"
                              /> */}
                                <img
  src={item.img_name ? item.img_name : ProductImage} // Use fallback if img_name is unavailable
  alt={getBannerOrImageAltTag('image',item) || "Default Alt Text"} // Fallback alt text
  className="product-img"
/>
                            </div>

                            {/* Details Section */}
                            <div className="pickup_item_img_info">
                              <p className="pickup_item_Name">{item.title}</p>
                              <p className="r_cart_prod_info">
                                {item.productCat.title}
                              </p>
                              <p
                                className="att_cart_prod_info"
                                dangerouslySetInnerHTML={{
                                  __html: Object.entries(item.attributes)
                                    .map(
                                      ([key, value]) =>
                                        `<div class="attr_blok"><i>${key}</i> : ${String(
                                          value
                                        )}</div>`
                                    )
                                    .join(" "),
                                }}
                              />
                              <div className="pickup_item_img_detail d-flex justify-content-between align-items-center">
                                <div className="pro_brand">
                                  Brand: {item.brand}
                                </div>
                                <div className="pro_brand">
                                  Price: ₹{" "}
                                  {parseFloat(item.base_value) * item.quantity}
                                </div>
                                {selectedVoucherApplied(
                                  item.product_id,
                                  item.item_id
                                ) && (
                                  <p className="voucher_id_txt">
                                    <i className="fa-solid fa-circle-check"></i>
                                    <span>
                                      {selectedVoucherLabel(item.product_id)}
                                    </span>
                                    <i
                                      className="fa-solid fa-xmark"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        // removeSelectedItemVoucher(
                                        //   item.product_id,
                                        //   item.item_id
                                        // )
                                        let voucher_id = getVoucherIdPerRemove(
                                          item.product_id
                                        );
                                        setRemoveVoucherPerItemData({
                                          cart_item_id: item.item_id,
                                          product_id: item.product_id,
                                          voucher_id: voucher_id,
                                        });
                                        setRemoveItemLevelVoucherPopUpStatus(
                                          true
                                        );
                                      }}
                                    ></i>
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Image Section */}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-4" key={refreshPriceKey}>
              <div className="cart-summary price_details">
                <h5>Price Details</h5>
                <div className="Total_Amount">
                  <p>Total:</p>
                  <p>₹ {totalValue}</p>
                </div>
                {/* {getOrderVoucherApplied() && (
                  <div className="Total_Amount">
                    <p>Order Voucher:</p>
                    <p>Applied</p>
                  </div>
                )} */}
                <div className="ship_Fee">
                  <p>Pickup Fee:</p>
                  {feesShow == false || pickupFeesAppliedVoucherStatus ? (
                    <p>
                      <span className="text-decoration-line-through">
                        ₹ {pickupFees}
                      </span>{" "}
                      Free
                    </p>
                  ) : (
                    <p>
                    {globalpickupFees && globalpickupFees !== pickupFees ? (
                      <span className="text-decoration-line-through">
                        ₹{globalpickupFees}
                      </span>
                    ) : null}{" "}
                    ₹{pickupFees}
                  </p>
                  )}
                </div>
                <div className="dascount_Amount">
                  <p>Voucher:</p>

                  <p>
                    {getOrderVoucherApplied() ? (
                      <p
                        className="text-success order_vouch"
                        style={{ fontSize: "10px" }}
                      >
                        {`${selectedVouchers[0].identifier} `}
                        <i
                          className="fa-solid fa-xmark"
                          style={{ cursor: "pointer", fontSize: "20px" }}
                          onClick={() => {
                            setRemoveOrderLevelVoucherPopUpStatus(true);
                          }}
                        ></i>
                      </p>
                    ) : appliedCartItemVoucher.length > 0 ? (
                      <button
                        className="text-success"
                        // data-bs-toggle="modal"
                        // data-bs-target="#voucherModal"
                        onClick={() => setVoucherPopupVisible(true)}
                      >
                        Apply More Voucher
                      </button>
                    ) : (
                      <button
                        className="text-success"
                        // data-bs-toggle="modal"
                        // data-bs-target="#voucherModal"
                        onClick={() => setVoucherPopupVisible(true)}
                      >
                        Apply Voucher
                      </button>
                    )}
                  </p>
                </div>
                {pickupFeesAppliedVoucherStatus ||
                appliedCartItemVoucher.length > 0 ||
                getOrderVoucherValueStatus() ? (
                  <div className="Total_Amount">
                    <p>Voucher Value:</p>

                    <p>
                      ₹{" "}
                      {getOrderVoucherValueStatus()
                        ? selectedVouchers[0].voucher_value
                        : voucherValueAmount}
                    </p>
                  </div>
                ) : (
                  <div className="Payable_Amount">
                    <p>Subtotal:</p>
                    {feesShow == false ? (
                      <p>₹ {Math.max(Number(totalValue), 0)}</p>
                    ) : (
                      <p>
                        ₹{" "}
                        {Math.max(
                          Number(
                            (totalValue ?? 0) -
                              (pickupFees ? parseFloat(pickupFees) : 0)
                          ),
                          0
                        )}
                      </p>
                    )}
                  </div>
                )}
                {pickupFeesAppliedVoucherStatus ||
                appliedCartItemVoucher.length > 0 ||
                getOrderVoucherValueStatus() ? (
                  <div className="Payable_Amount">
                    <p>Pay In Cash:</p>
                    {feesShow == false ||
                    pickupFeesAppliedVoucherStatus ||
                    getOrderVoucherValueStatus() ? (
                      <p>
                        ₹{" "}
                        {getOrderVoucherValueStatus()
                          ? "0"
                          : Math.max(Number(cashValueAmount), 0)}
                      </p>
                    ) : (
                      <p>
                        ₹{" "}
                        {Math.max(
                          Number(
                            (cashValueAmount ?? 0) -
                              (pickupFees ? parseFloat(pickupFees) : 0)
                          ),
                          0
                        )}
                      </p>
                    )}
                    {/* <p>₹ {cashValueAmount == null ? "0" : cashValueAmount}</p> */}
                  </div>
                ) : (
                  ""
                )}
                <div className="pp_tc d-flex form-check mt-3">
                  <input
                    type="checkbox"
                    id="agree"
                    checked={isAgreed}
                    onChange={(e) => {
                      setIsAgreed(e.target.checked);
                      setError(null);
                    }}
                    className="form-check-input"
                  />
                  <label htmlFor="agree" className="form-check-label">
                    By placing your order, you agree to Selsmart's
                    <a onClick={handlePrivacy} className="text-success">
                      {" "}
                      Privacy Policy
                    </a>{" "}
                    and
                    <a
                      onClick={handleTermsOfConditions}
                      className="text-success"
                    >
                      {" "}
                      Terms &amp; Conditions
                    </a>
                    .
                  </label>
                </div>
                {error && <p className="error-checkbox">{error}</p>}{" "}
                {/* Render error message if exists */}
                <div>
                  {/* Submit Pickup Request button */}
                  <button
                    className="Proceed_checkout btn  btn-success w-100 mt-3"
                    onClick={handleButtonClick}
                    // disabled={!isFormValid()}
                    // onClick={handleSubmit}
                  >
                    Proceed to checkout
                  </button>

                  {/* Confirmation Popup */}
                  {showConfirmationPopup && (
                    <div className="confirmation-overlay">
                      <div className="confirmation-content">
                        <h3>Order Confirmation</h3>
                        <p>Are you sure you want to place this order?</p>

                        <button
                          className=" canc btn btn-outline-success"
                          onClick={() => setShowConfirmationPopup(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="yes_s btn btn-success"
                          onClick={handleConfirmOrder}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Modal for Success Message */}

                  <div className={isLoading ? "page-blur" : ""}>
                    {!isLoading && showModal && (
                      <div className="modal-overlay-order-submit">
                        <div className="modal-content-order-submit">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="check-icon"
                          />
                          <h3>Thank you for using Selsmart!</h3>
                          <p>
                            Your order No. <strong>{order_Number}</strong>{" "}
                            successfully placed
                            {selectPickupSlotDate ? (
                              <p>
                                and scheduled on{" "}
                                <strong>
                                  {orderDate
                                    ? new Date(orderDate).toLocaleDateString(
                                        "en-GB",
                                        {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                        }
                                      )
                                    : "N/A"}
                                </strong>{" "}
                                for pickup.
                              </p>
                            ) : (
                              "."
                            )}
                          </p>
                          <p>
                            You will receive an email confirmation shortly with
                            the details. If you have any questions, please
                            contact our support team.
                          </p>
                          <button
                            className="got-it-button"
                            onClick={handleGotItClick}
                          >
                            Got it
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* applied voucher modal */}

                  {voucherPopupVisible && (
                    <div className="custom-voucher-modal">
                      <div className="voucher-modal-overlay"></div>
                      <div className={`voucher-modal-content ${vouchersData.length === 0? "no_fix_height": ""}`}>
                        {/* Modal Header */}
                        <div className="voucher-modal-header">
                          <h5>Available Voucher</h5>
                          <button
                            className="voucher-btn-close"
                            onClick={handleClose}
                          >
                            &times;
                          </button>
                        </div>

                        {/* Modal Body */}
                        {vouchersData.length > 0 ? (
                          <div className="voucher-modal-body">
                            <div className="apply_input_wrap position-relative">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="e.g: DAIKIN321"
                                value={getApplyVoucherValue()}
                                readOnly
                              />
                              <button
                                className=" apply_btn btn btn-success mt-2 w-100"
                                onClick={applyVoucher}
                              >
                                Apply
                              </button>
                            </div>
                            <small className="text-success-applied d-block- mt-2">
                              <i
                                className="fa-solid fa-circle-check"
                                style={{ marginRight: "5px", fontSize: "20px" }}
                              ></i>
                              Voucher verified and will be applied at checkout.
                            </small>

                            {itemOrOrderVoucherSelectionError != "" && (
                              <small className="text-error-applied d-block- mt-2">
                                {itemOrOrderVoucherSelectionError}
                              </small>
                            )}

                            {/* Voucher List */}
                            <div className="vouchers-list">
                              {vouchersData.map((v: any, index: number) => {
                                const isSelected =
                                  appliedDummyVoucherData.find(
                                    (vo: any) => vo.voucher_id === v.voucher_id
                                  )?.identifier === v.identifier;
                                const isSelectedVoucher =
                                  selectedVouchers.find(
                                    (vo: any) => vo.voucher_id === v.voucher_id
                                  )?.identifier === v.identifier;

                                return (
                                  <div
                                    key={index}
                                    className={`voucher-card ${
                                      isSelectedVoucher
                                        ? "selected-voucher"
                                        : ""
                                    } border rounded mb-3- p-3 position-relative`}
                                  >
                                    <div
                                      className={`green_vertical_div ${
                                        moreButtonIndex === index
                                          ? "corner"
                                          : ""
                                      }`}
                                      style={{
                                        background: "#2e7d32",
                                        width: "60px",
                                        height: "307px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="40"
                                        height="40"
                                        viewBox="0 0 40 40"
                                        fill="none"
                                      >
                                        <g clip-path="url(#clip0_2708_5074)">
                                          <path
                                            d="M26.6667 0H26.45C25.7041 0.00708636 24.9817 0.261689 24.3962 0.723832C23.8106 1.18598 23.3952 1.82949 23.215 2.55333C23.022 3.25806 22.6029 3.87987 22.022 4.32309C21.4411 4.76631 20.7307 5.00639 20 5.00639C19.2693 5.00639 18.5589 4.76631 17.978 4.32309C17.3971 3.87987 16.978 3.25806 16.785 2.55333C16.6048 1.82949 16.1894 1.18598 15.6038 0.723832C15.0183 0.261689 14.2959 0.00708636 13.55 0L13.3333 0C11.124 0.00264643 9.00593 0.88147 7.4437 2.4437C5.88147 4.00593 5.00265 6.12401 5 8.33333V35C5 36.3261 5.52678 37.5979 6.46447 38.5355C7.40215 39.4732 8.67392 40 10 40H13.55C14.2959 39.9929 15.0183 39.7383 15.6038 39.2762C16.1894 38.814 16.6048 38.1705 16.785 37.4467C16.978 36.7419 17.3971 36.1201 17.978 35.6769C18.5589 35.2337 19.2693 34.9936 20 34.9936C20.7307 34.9936 21.4411 35.2337 22.022 35.6769C22.6029 36.1201 23.022 36.7419 23.215 37.4467C23.3952 38.1705 23.8106 38.814 24.3962 39.2762C24.9817 39.7383 25.7041 39.9929 26.45 40H30C31.3261 40 32.5979 39.4732 33.5355 38.5355C34.4732 37.5979 35 36.3261 35 35V8.33333C34.9974 6.12401 34.1185 4.00593 32.5563 2.4437C30.9941 0.88147 28.876 0.00264643 26.6667 0V0ZM30 36.6667L26.4283 36.5617C26.0369 35.1474 25.1897 33.9017 24.0182 33.018C22.8467 32.1342 21.4163 31.6616 19.9489 31.6736C18.4815 31.6856 17.059 32.1814 15.902 33.0841C14.7451 33.9869 13.9183 35.2462 13.55 36.6667H10C9.55797 36.6667 9.13405 36.4911 8.82149 36.1785C8.50893 35.866 8.33333 35.442 8.33333 35V28.3333H11.6667C12.1087 28.3333 12.5326 28.1577 12.8452 27.8452C13.1577 27.5326 13.3333 27.1087 13.3333 26.6667C13.3333 26.2246 13.1577 25.8007 12.8452 25.4882C12.5326 25.1756 12.1087 25 11.6667 25H8.33333V8.33333C8.33333 7.00725 8.86012 5.73548 9.7978 4.7978C10.7355 3.86012 12.0073 3.33333 13.3333 3.33333L13.5717 3.43833C13.962 4.84404 14.8017 6.08341 15.9624 6.96725C17.1231 7.8511 18.5411 8.33087 20 8.33333C21.4786 8.32075 22.9126 7.8255 24.0838 6.92294C25.2551 6.02037 26.0994 4.75991 26.4883 3.33333H26.6667C27.9928 3.33333 29.2645 3.86012 30.2022 4.7978C31.1399 5.73548 31.6667 7.00725 31.6667 8.33333V25H28.3333C27.8913 25 27.4674 25.1756 27.1548 25.4882C26.8423 25.8007 26.6667 26.2246 26.6667 26.6667C26.6667 27.1087 26.8423 27.5326 27.1548 27.8452C27.4674 28.1577 27.8913 28.3333 28.3333 28.3333H31.6667V35C31.6667 35.442 31.4911 35.866 31.1785 36.1785C30.866 36.4911 30.442 36.6667 30 36.6667Z"
                                            fill="#FCFCFD"
                                          />
                                          <path
                                            d="M21.667 25H18.3337C17.8916 25 17.4677 25.1756 17.1551 25.4882C16.8426 25.8007 16.667 26.2246 16.667 26.6667C16.667 27.1087 16.8426 27.5326 17.1551 27.8452C17.4677 28.1578 17.8916 28.3334 18.3337 28.3334H21.667C22.109 28.3334 22.5329 28.1578 22.8455 27.8452C23.1581 27.5326 23.3336 27.1087 23.3336 26.6667C23.3336 26.2246 23.1581 25.8007 22.8455 25.4882C22.5329 25.1756 22.109 25 21.667 25Z"
                                            fill="#FCFCFD"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_2708_5074">
                                            <rect
                                              width="40"
                                              height="40"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                    {moreButtonIndex === index && (
                                      <div className="bottom_line"></div>
                                    )}
                                    <div className="d-flex- justify-content-between align-items-center">
                                      <div className="wrap_height">
                                        <div className="d-flex justify-content-between">
                                          <div className="top_voucher_id">
                                            <h6 className="mb-1">
                                              {v.identifier}
                                            </h6>
                                            <p className="text-muted small mb-0">
                                              {v.depends_on === 1
                                                ? `Get ${v.voucher_value} of order with this voucher`
                                                : `Get Item value ${v.voucher_value} with this voucher`}
                                            </p>
                                          </div>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={isSelectedVoucher}
                                            disabled={isSelected ? true : false}
                                            onChange={() =>
                                              handleVoucherSelection(v)
                                            }
                                          />
                                        </div>
                                        <p className="text-muted dot_border mb-0">
                                          {v.description
                                            ? v.description.slice(0, 99)
                                            : ""}
                                        </p>
                                        {moreButtonIndex !== index &&
                                          v.description &&
                                          v.description.length > 100 && (
                                            <button
                                              className="m_button"
                                              onClick={() => {
                                                if (moreButtonIndex == null) {
                                                  setMoreButtonIndex(index);
                                                } else if (
                                                  moreButtonIndex === index
                                                ) {
                                                  setMoreButtonIndex(null); //
                                                } else if (
                                                  moreButtonIndex !== index
                                                ) {
                                                  setMoreButtonIndex(index);
                                                }
                                              }}
                                            >
                                              Show More
                                            </button>
                                          )}
                                      </div>
                                      {index === moreButtonIndex && (
                                        <div className="tms_list">
                                          <h3>Term and Conditions apply</h3>
                                          <ul>
                                            <li key={0}>{v.description}</li>
                                          </ul>
                                        </div>
                                      )}
                                      {moreButtonIndex === index && (
                                        <button
                                          className="m_button lft"
                                          onClick={() => {
                                            if (moreButtonIndex == null) {
                                              setMoreButtonIndex(index);
                                            } else if (
                                              moreButtonIndex === index
                                            ) {
                                              setMoreButtonIndex(null); //
                                            } else if (
                                              moreButtonIndex !== index
                                            ) {
                                              setMoreButtonIndex(index);
                                            }
                                          }}
                                        >
                                          Show Less
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <div className="no-vouchers">
                            <p>No vouchers available for this item or order.</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* item level voucher remove modal */}

                  {removeItemLevelVoucherPopUpStatus && (
                    <div className="confirmation-overlay">
                      <div className="confirmation-content">
                        <h3>Voucher</h3>
                        <p>Are you sure you want to remove this voucher?</p>

                        <button
                          className=" canc btn btn-outline-success"
                          onClick={() =>
                            setRemoveItemLevelVoucherPopUpStatus(false)
                          }
                        >
                          Cancel
                        </button>
                        <button
                          className="yes_s btn btn-success"
                          onClick={() => removeVoucherPerItemSuccess()}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  )}
                  {/* remove voucher for all item modal */}
                  {removeAllItemLevelVoucherPopUpStatus && (
                    <div className="confirmation-overlay">
                      <div className="confirmation-content">
                        <h3>Voucher</h3>
                        <p>
                          Are you sure you want to remove same voucher for all
                          items?
                        </p>

                        <button
                          className=" canc btn btn-outline-success"
                          onClick={() => {
                            removeSelectedSingleItemVoucher(
                              removeVoucherPerItemData.product_id,
                              removeVoucherPerItemData.cart_item_id
                            );
                            setRemoveAllItemLevelVoucherPopUpStatus(false);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="yes_s btn btn-success"
                          onClick={() => {
                            removeSelectedAllItemVoucher(
                              removeVoucherPerItemData.product_id,
                              removeVoucherPerItemData.cart_item_id
                            );
                            setRemoveAllItemLevelVoucherPopUpStatus(false);
                          }}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  )}
                  {removeOrderLevelVoucherPopUpStatus && (
                    <div className="confirmation-overlay">
                      <div className="confirmation-content">
                        <h3>Order Voucher</h3>
                        <p>Are you sure you want to remove this voucher?</p>

                        <button
                          className=" canc btn btn-outline-success"
                          onClick={() =>
                            setRemoveOrderLevelVoucherPopUpStatus(false)
                          }
                        >
                          Cancel
                        </button>
                        <button
                          className="yes_s btn btn-success"
                          onClick={() => {
                            setSelectedVouchers([]);
                            setApplyVoucherButton(false);
                            setAppliedDummyVoucherData([]);
                            setSelectedSessionStorageVoucher([]);
                            sessionStorage.setItem(
                              "sessionAppliedRemoveCartItemVoucher",
                              JSON.stringify([])
                            );
                            setRemoveOrderLevelVoucherPopUpStatus(false);
                          }}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  )}

                  {showModalInfo && (
                    <div className="popup_cart" style={modalStyles.overlay}>
                      <div style={modalStyles.modal}>
                        {/* <FontAwesomeIcon className="cart-empty" icon={faShoppingCart} /> */}
                        <p className="cart-empty-msg">{popupMsg}</p>
                        <button
                          className="cart-empty-button"
                          onClick={handleCloseModalClick}
                        >
                          Got it
                        </button>
                      </div>
                    </div>
                  )}

                  {showPrice && (
                    <div className="popup_cart" style={modalStyles.overlay}>
                      <div style={modalStyles.modal}>
                        {/* <FontAwesomeIcon className="cart-empty" icon={faShoppingCart} /> */}
                        <p className="cart-empty-msg">
                          Product price has changed according to your city.
                        </p>
                        <button
                          className="cart-empty-button"
                          onClick={handleClosePrice}
                        >
                          Got it
                        </button>
                      </div>
                    </div>
                  )}

                  {/* {showModalInfo && (
                      <div className="modal-overlays">
                        <div className="modal-contents">
                          
                          <p className="heading-popup-trashs">
                           {popupMsg}
                          </p>
                          <div className="modal-actionss">
                            <button
                              className="modal-cancel-button btn btn-success"
                              onClick={handleCloseModalClick}
                            >
                              Got It
                            </button>
                          </div>
                        </div>
                      </div>
                    )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default OrderSummaryPage;
